import React, {useEffect, useMemo, useRef, useState} from 'react';
import {useSearchParams} from "react-router-dom";
import {DataTable} from 'primereact/datatable';
import {Column, ColumnFilterElementTemplateOptions} from 'primereact/column';
import {classNames} from "primereact/utils";
import {Badge} from "primereact/badge";
import {Button} from "primereact/button";
import 'react-h5-audio-player/lib/styles.css';
import {Dialog} from "primereact/dialog";
import MonitoringListNav from "../MonitoringListNav";
import {
    clearMonitoringDashboard,
    getCampaignFilterList,
    getEventMonitorToUserDetail,
    getMonitoringDashboard,
    getMonitoringWithPaginationFilterAndSorting,
    getUserSortFields
} from "../../../redux/api/apiMonitoringList";
import {useAppDispatch, useAppSelector} from "../../../redux/hooks";
import {Paginator} from "primereact/paginator";
import {
    getAudioUrlForPlayer,
    setAudioUnavailable,
    setCurrentPage,
    setCurrentPageSize,
    setMonitoringFilter, setMonitoringUiFilters, updateMonitoringFilter
} from "../../../redux/actions/actionsMonitoringList";
import {areSearchParamsEqual, buildMonitoringSearchParams, readInitialMonitoringUrlState} from "../../../utils/monitoringUrlState";
import {applyMonitoringHubBatches, parseMonitoringHubPayload} from "../../../utils/monitoringHubMerge";
import {
    applyMonitoringDashboardHubBatches,
    createMonitoringDashboardTracker,
    MonitoringDashboardTracker
} from "../../../utils/monitoringDashboardHub";
import {keysFirstLetterToLowerCase} from "../../../utils/callSessionUtils";
import {logHub} from "../../../utils/appEventLogs";
import {getHashPath} from "../../../utils/encodedUrlQuery";
import {withBranchIdSortField} from "../../../redux/api/sortFieldsFetchState";
import {MultiSelect} from "primereact/multiselect";
import {Calendar} from "primereact/calendar";
import {UPLOAD_AUDIO_LOADING} from "../../../redux/types/types";
import {DataRow, DecodedToken} from "../../../types/types";
import {formatBranchDisplayLabel} from "../../../utils/formatBranchDisplayLabel";
import {getAllSimpleUsers} from "../../../redux/api/api";
import {getUsersManagerUserBranchesData} from "../../../redux/api/apiUsersList";
import MonitoringListDetails from "../MonitoringList/MonitoringListDetails";
import {HubConnectionBuilder} from "@microsoft/signalr";
import {WSS_URL} from "../../../redux/config";
import * as signalR from "@microsoft/signalr";
import {setMonitoringHubError} from "../../../redux/actions/actionsWebRTC";
import {GET_MONITORING, GET_MONITORING_DASHBOARD, GET_MONITORINGS} from "../../../redux/types/typesMonitoringList";
import {jwtDecode} from "jwt-decode";
import {SET_USER_STATUS_SUCCESS} from "../../../redux/types/typesUsersList";
import {resetAllMonitoringFilters} from "../../../redux/actions/actions";
import {setStatisticsCurrentPage} from "../../../redux/actions/actionsStatisticsList";
import {registerHubConnection, unregisterHubConnection} from "../../JsSip/GlobalJsSIP";
import {InputText} from "primereact/inputtext";
import {useEffectiveOnlineStatus} from "../../../utils/internetReachability";

interface NetworkInformation extends EventTarget {
    downlink: number;
    effectiveType: string;
}

const MonitoringBranches = (props: any) => {
    const dispatch = useAppDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    const [initialMonitoringUrlState] = useState(readInitialMonitoringUrlState);
    const monitoringList = useAppSelector(state => state.MonitoringListReducer?.monitoringList);
    const userSortFields: any = useAppSelector(state => state.RolesReducer.userSortFields);
    const monitoringSortFields = useMemo(
        () => withBranchIdSortField(userSortFields),
        [userSortFields]
    );
    const campaignList = useAppSelector(state => state.MonitoringListReducer?.campaignListName);
    const monitoringData = useAppSelector(state => state.MonitoringListReducer?.monitoringData);
    const paginationSize = useAppSelector(state => state.MonitoringListReducer.paginationSize);
    const pagination = useAppSelector(state => state.MonitoringListReducer.pagination);
    const loader = useAppSelector(state => state.MonitoringListReducer.loading);
    const paginationPage = useAppSelector(state => state.MonitoringListReducer.paginationPage);
    const statusDictionary = useAppSelector(state => state.MonitoringListReducer.statusDictionary);
    const callResetDictionary = useAppSelector(state => state.MonitoringListReducer.callResetDictionary);
    const forcedClosingDictionary = useAppSelector(state => state.MonitoringListReducer.forcedClosingDictionary);
    const ownerTypeDictionary = useAppSelector(state => state.MonitoringListReducer.ownerTypeDictionary);
    const callTypeDictionary = useAppSelector(state => state.MonitoringListReducer.callTypeDictionary);
    const clearFilters = useAppSelector(state => state.MonitoringListReducer.clearFilters)
    const user = useAppSelector(state => state.UsersReducer.userData);
    // @ts-ignore
    const activeClick = useAppSelector(state => state.UsersListReducer.activeClick);
    const [first, setFirst] = useState(() => (initialMonitoringUrlState.page - 1) * initialMonitoringUrlState.size);
    const [selectedRowData, setSelectedRowData] = useState<any | null>(null);
    const [selectedRowExpansion, setSelectedRowExpansion] = useState<any | null>(null);
    const [selectedSessionRowExpansion] = useState<any | null>(null);
    const [selectedBSessionRowExpansion] = useState<any | null>(null);
    const [orderBy, setOrderBy] = useState<any>(initialMonitoringUrlState.orderBy);
    const [isDescFilter, setIsDescFilter] = useState<boolean>(initialMonitoringUrlState.isDesc);
    const [sortOrder, setSortOrder] = useState<number>(initialMonitoringUrlState.sortOrder);
    const [startTime, setStartTime] = useState<any>(initialMonitoringUrlState.startTime);
    const [endTime, setEndTime] = useState<any>(initialMonitoringUrlState.endTime);
    const [startFinishTime, setStartFinishTime] = useState<any>(initialMonitoringUrlState.startFinishTime);
    const [endFinishTime, setEndFinishTime] = useState<any>(initialMonitoringUrlState.endFinishTime);
    const [filterCampaignId, setFilterCampaignId] = useState<any>(initialMonitoringUrlState.filterCampaignId);
    const [filterNameTo, setFilterNameTo] = useState<any>(initialMonitoringUrlState.filterNameTo);
    const [filterNameFrom, setFilterNameFrom] = useState<any>(initialMonitoringUrlState.filterNameFrom);
    const [filterAmdHangup, setFilterAmdHangup] = useState<any>(initialMonitoringUrlState.filterAmdHangup);
    const [filterCallReset, setFilterCallReset] = useState<any>(initialMonitoringUrlState.filterCallReset);
    const [filterStatus, setFilterStatus] = useState<any>(initialMonitoringUrlState.filterStatus);
    const [filterCampaignName, setFilterCampaignName] = useState<any>(initialMonitoringUrlState.filterCampaignName);
    const [filterBranchName, setFilterBranchName] = useState<any>(initialMonitoringUrlState.filterBranchName);
    const [filterQueueName, setFilterQueueName] = useState<any>(initialMonitoringUrlState.filterQueueName);
    const [filterFullName, setFilterFullName] = useState<any>(initialMonitoringUrlState.filterFullName);
    const [filterANumber, setFilterANumber] = useState<any>(initialMonitoringUrlState.filterANumber);
    const [filterTypeChannel, setFilterTypeChannel] = useState<any>(initialMonitoringUrlState.filterTypeChannel);
    const [filterOwnerType, setFilterOwnerType] = useState<any>(initialMonitoringUrlState.filterOwnerType);
    const [filterDirection, setFilterDirection] = useState<any>(initialMonitoringUrlState.filterDirection);
    const [filterDateTime, setFilterDateTime] = useState<any>(initialMonitoringUrlState.filterDateTime || false);
    const [filterEndDateTime, setFilterEndDateTime] = useState<any>(initialMonitoringUrlState.filterEndDateTime || false);
    const [filterFinishDateTime, setFilterFinishDateTime] = useState<any>(initialMonitoringUrlState.filterFinishDateTime || false);
    const [filterFinishEndDateTime, setFilterFinishEndDateTime] = useState<any>(initialMonitoringUrlState.filterFinishEndDateTime || false);
    const [fullCallDurationStartTime, setfullCallDurationStartTime] = useState<any>(initialMonitoringUrlState.fullCallDurationStartTime || getDefaultStartTime());
    const [fullCallDurationEndTime, setfullCallDurationEndTime] = useState<any>(initialMonitoringUrlState.fullCallDurationEndTime || getDefaultStartTime());
    const [durationStartTime, setDurationStartTime] = useState<any>(initialMonitoringUrlState.durationStartTime || getDefaultStartTime());
    const [durationEndTime, setDurationEndTime] = useState<any>(initialMonitoringUrlState.durationEndTime || getDefaultStartTime());
    const [reactionClientStartTime, setReactionClientStartTime] = useState<any>(initialMonitoringUrlState.reactionClientStartTime || getDefaultStartTime());
    const [reactionClientEndTime, setReactionClientEndTime] = useState<any>(initialMonitoringUrlState.reactionClientEndTime || getDefaultStartTime());
    const [reactionOperatorStartTime, setReactionOperatorStartTime] = useState<any>(initialMonitoringUrlState.reactionOperatorStartTime || getDefaultStartTime());
    const [reactionOperatorEndTime, setReactionOperatorEndTime] = useState<any>(initialMonitoringUrlState.reactionOperatorEndTime || getDefaultStartTime());
    const [visible, setVisible] = useState(false);
    const [filterCallOwner, setFilterCallOwner] = useState<any>(initialMonitoringUrlState.filterCallOwner);
    const [activeTab, setActiveTab] = useState<string>('table1');
    const dataTableRef = useRef<DataTable | any>(null);
    // @ts-ignore
    const queuesDirectoryDirectionType = useAppSelector(state => state.QueueListReducer.queuesDirectoryDirectionType) as any;
    const [expandedRows, setExpandedRows] = useState<any>([]);
    const [expandedSessionRows, setExpandedSessionRows] = useState<any>([]);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [key, setKey] = useState(1);
    const jwtToken = useAppSelector(state => state.UsersReducer.userData.jwtToken);
    const rolesVision = useAppSelector(state => state.RolesReducer.rolesVision) as unknown as Record<string, string[]>;
    const hasUsersAccess = !!rolesVision?.hasOwnProperty('Users');
    const hasBranchAccess = !!rolesVision?.hasOwnProperty('Branch');
    // @ts-ignore
    const usersData = useAppSelector(state => state.CompaniesListReducer.allSimpleUsers);
    const branches = useAppSelector(state => state.UsersListReducer.branches);
    const activeColumns = useMemo(() => {
        return [...(monitoringSortFields?.fields || [])]
            .filter((item: { isActive: any }) => item.isActive)
            .sort((a: { order: number }, b: { order: number }) => a.order - b.order);
    }, [monitoringSortFields]);
    const pageChanged = useAppSelector(state => state.MonitoringListReducer.pageChanged);
    const [fullCallDuration, setFullCallDuration] = useState<boolean>(initialMonitoringUrlState.fullCallDuration);
    const [duration, setDuration] = useState<boolean>(initialMonitoringUrlState.duration);
    const [reactionClient, setReactionClient] = useState<boolean>(initialMonitoringUrlState.reactionClient);
    const [reactionOperator, setReactionOperator] = useState<boolean>(initialMonitoringUrlState.reactionOperator);
    const [totalItems, setTotalItems] = useState<number>(paginationSize);
    const monitoringFilterData = useAppSelector(state => state.MonitoringListReducer?.monitoringFilterData);
    const monitoringDashboard = useAppSelector(state => state.MonitoringListReducer?.monitoringDashboard);
    const [monitoringHubConnection, setMonitoringHubConnection] = useState(null) as any;
    const [allMonitoring, setAllMonitoring] = useState<any>(null);
    const [allStatuses, setAllStatuses] = useState<any>(null);
    const autoReload = useAppSelector(state => state.MonitoringListReducer.autoReload);
    const reconnectSession = useAppSelector(state => state.WebRTCReducer.reconnectSession);
    const spyCallAnsweredTick = useAppSelector(state => state.WebRTCReducer.spyCallAnsweredTick);
    const isOnline = useEffectiveOnlineStatus();
    const isReachableOnlineRef = useRef(isOnline);
    isReachableOnlineRef.current = isOnline;
    const internetConnection = (navigator as any).connection as NetworkInformation | undefined;
    const [activity, setActivity] = useState<any>(false);
    const [toggleButtonActivity, setToggleButtonActivity] = useState<any>(false);
    const prevDataSortRef = useRef<any>(null);
    const prevDashboardRequestRef = useRef<string>('');
    const isFirstRun = useRef(true);
    const hasInitializedPagination = useRef(false);
    const skipUrlWriteRef = useRef(true);
    const pendingUrlFilterSkipsRef = useRef(
        initialMonitoringUrlState.hasAny
            ? (Object.keys(initialMonitoringUrlState.uiFilters || {}).length > 0 ? 2 : 1)
            : 0
    );
    const monitoringListRef = useRef(monitoringList);
    const autoReloadRef = useRef(autoReload);
    const paginationPageRef = useRef(paginationPage);
    const paginationSizeRef = useRef(paginationSize);
    const monitoringFilterDataRef = useRef(monitoringFilterData);
    const monitoringDataRef = useRef(monitoringData);
    const jwtTokenRef = useRef(jwtToken);
    const hubEventQueueRef = useRef<any[][]>([]);
    const hubFlushScheduledRef = useRef(false);
    const restInFlightRef = useRef(false);
    const batchesDuringRestRef = useRef<any[][]>([]);
    const restRequestIdRef = useRef(0);
    const enqueueHubEventRef = useRef<(raw: any) => void>(() => {});
    const monitoringDashboardRef = useRef(monitoringDashboard);
    const dashboardTrackerRef = useRef<MonitoringDashboardTracker | null>(null);
    const batchesDuringDashboardRef = useRef<any[][]>([]);
    const dashboardRequestIdRef = useRef(0);
    const prevAutoReloadRef = useRef(autoReload);

    if (!hubFlushScheduledRef.current && !restInFlightRef.current) {
        monitoringListRef.current = monitoringList;
    }
    autoReloadRef.current = autoReload;
    paginationPageRef.current = paginationPage;
    paginationSizeRef.current = paginationSize;
    monitoringFilterDataRef.current = monitoringFilterData;
    monitoringDataRef.current = monitoringData;
    jwtTokenRef.current = jwtToken;
    if (!hubFlushScheduledRef.current && !dashboardTrackerRef.current) {
        monitoringDashboardRef.current = monitoringDashboard;
    }
    const [isFinishDateFocused, setIsFinishDateFocused] = useState<boolean>(false);
    const [isFinishEndDateFocused, setIsFinishEndDateFocused] = useState<boolean>(false);
    const [isStartDateFocused, setIsStartDateFocused] = useState<boolean>(false);
    const [isEndDateFocused, setIsEndDateFocused] = useState<boolean>(false);
    const [isStartFinishTimeFocused, setIsStartFinishTimeFocused] = useState<boolean>(false);
    const [isEndFinishTimeFocused, setIsEndFinishTimeFocused] = useState<boolean>(false);
    const [hasEndFilter, setHasEndFilter] = useState<boolean>(initialMonitoringUrlState.hasEndFilter);
    const [hasStartFilter, setHasStartFilter] = useState<boolean>(initialMonitoringUrlState.hasStartFilter);

    function getDefaultStartTime(): Date {
        const d = new Date();
        d.setHours(0, 0, 0, 0);
        return d;
    }

    function getDefaultEndTime(): Date {
        const d = new Date();
        d.setHours(23, 59, 59, 0);
        return d;
    }

    function getDefaultStartDate(): Date {
        return new Date();
    }

    function getDefaultEndDate(): Date {
        return new Date();
    }

    const isTimeFilterActive = (filterName: string) => {
        let result = false;
        switch (filterName) {
            case 'fullCallDuration':
                result = fullCallDuration;
                break;
            case 'duration':
                result = duration;
                break;
            case 'reactionClient':
                result = reactionClient;
                break;
            case 'reactionOperator':
                result = reactionOperator;
                break;
            default:
                result = false;
        }

        return result;
    };

    const getActiveFilterStyle = (isActive: boolean) => {
        return isActive ? {
            border: '2px solid #007ad9',
            backgroundColor: '#e3f2fd',
            boxShadow: '0 0 5px rgba(0, 122, 217, 0.3)'
        } : {};
    };

    const getActiveFilterClassName = (baseClassName: string, isActive: boolean) => {
        const result = isActive ? `${baseClassName} active-time-filter` : baseClassName;
        return result;
    };


    let decodedToken: DecodedToken;
    if (jwtToken?.jwtToken) {
        decodedToken = jwtDecode(jwtToken?.jwtToken);
    }
    const [sortData, setSortData] = useState<any>({
        pageNumber: initialMonitoringUrlState.page,
        pageSize: initialMonitoringUrlState.size,
        sort: {
            orderBy: orderBy ? orderBy : "Id",
            isDesc: isDescFilter
        },
        filter: [],
        username: user.userName
    });

    const [networkInfo, setNetworkInfo] = useState({
        downlink: internetConnection?.downlink ?? null,
        effectiveType: internetConnection?.effectiveType ?? null
    });

    useEffect(() => {
        if (spyCallAnsweredTick) {
            setVisible(false);
        }
    }, [spyCallAnsweredTick]);

    useEffect(() => {
        const updateNetworkInfo = () => {
            setNetworkInfo({
                downlink: internetConnection?.downlink ?? null,
                effectiveType: internetConnection?.effectiveType ?? null
            });
        };

        window.addEventListener('online', updateNetworkInfo);
        window.addEventListener('offline', updateNetworkInfo);
        internetConnection?.addEventListener('change', updateNetworkInfo);

        return () => {
            window.removeEventListener('online', updateNetworkInfo);
            window.removeEventListener('offline', updateNetworkInfo);
            internetConnection?.removeEventListener('change', updateNetworkInfo);
        };
    }, [internetConnection]);

    function startConnection(token: string) {
        if (connectionRef.current) {
            return connectionRef.current;
        }

        if (!token) {
            return null;
        }

        const connection = new HubConnectionBuilder()
            .withUrl(`${WSS_URL}MonitoringHub`, {
                skipNegotiation: true,
                transport: signalR.HttpTransportType.WebSockets,
                accessTokenFactory: () => token
            })
            .withAutomaticReconnect({
                nextRetryDelayInMilliseconds: (retryContext) => {
                    if (retryContext.previousRetryCount < 12) {
                        return 5000;
                    }
                    return 30000;
                }
            }).build();

        connection.serverTimeoutInMilliseconds = 60000;
        connection.keepAliveIntervalInMilliseconds = 15000;

        connection.onreconnected(() => {
            logHub('MonitoringHub', 'reconnected');
            console.log(`[${new Date().toISOString()}] Information: WebSocket reconnected to ${WSS_URL}MonitoringHub`);
            connection.invoke("UserConnectedWithType", decodedToken[`x-access-userid`], "cc").then(() => {
                dispatch(setMonitoringHubError(false));
            })
                .catch((error: any) => {
                    logHub('MonitoringHub', 'invoke_failed', {message: error?.message, method: 'UserConnectedWithType'});
                    dispatch(setMonitoringHubError(true));
                }).catch(err => console.error(err));

            reconnectionAttemptsRef.current = 0;
            lastReconnectionTimeRef.current = 0;
        });

        connection.onreconnecting((error) => {
            logHub('MonitoringHub', 'reconnecting', {message: error?.message});
            console.warn(`[${new Date().toISOString()}] Warning: WebSocket reconnecting...`, error);
        });


        connection.onclose((error) => {
            logHub('MonitoringHub', 'disconnected', {message: error?.message});
            dispatch(setMonitoringHubError(true));
            setMonitoringHubConnection(null);
            connectionRef.current = null;
        });

        connection
            .start()
            .then(() => {
                logHub('MonitoringHub', 'connected');
                setMonitoringHubConnection(connection);
                connectionRef.current = connection;
                dispatch(setMonitoringHubError(false));

                connection.off('MonitorUserFirstEvent');
                connection.off('MonitorUserEvent');

                connection.on('MonitorUserFirstEvent', AllCampaigns => {
                    setAllMonitoring(JSON.parse(AllCampaigns));
                });
                connection.on('MonitorUserEvent', AllStatuses => {
                    setAllMonitoring(null);
                    enqueueHubEventRef.current(AllStatuses);
                });
                connection.invoke("UserConnectedWithType", decodedToken[`x-access-userid`], "cc").then(() => {
                    dispatch(setMonitoringHubError(false));
                })
                    .catch((error: any) => {
                        logHub('MonitoringHub', 'invoke_failed', {message: error?.message, method: 'UserConnectedWithType'});
                        dispatch(setMonitoringHubError(true));
                    });

                reconnectionAttemptsRef.current = 0;
                lastReconnectionTimeRef.current = 0;
            })
            .catch((error: any) => {
                logHub('MonitoringHub', 'failed', {message: error?.message});
                dispatch(setMonitoringHubError(true));
                setMonitoringHubConnection(null);
                connectionRef.current = null;
                setTimeout(() => {
                    const isLoggedOut = sessionStorage.getItem('isLoggedOut') === 'true';
                    if (!isLoggedOut && isReachableOnlineRef.current) {
                        startConnection(jwtToken?.jwtToken || "");
                    }
                }, 10000);
            });
        registerHubConnection(connection);
        return connection;
    }

    const connectionRef = useRef<any>(null);
    const reconnectionAttemptsRef = useRef(0);
    const lastReconnectionTimeRef = useRef(0);

    const updateOpenedMonitoringDetails = (batches: any[][]) => {
        const monitoringItem = monitoringDataRef.current;
        if (!monitoringItem?.id || !batches?.length) {
            return;
        }

        const getAllIds = (arr: any[]): any[] => {
            let ids: any[] = [];

            arr.forEach(obj => {
                if (obj.item && obj.item.id) {
                    ids.push(obj.item.id);
                }

                if (obj.children && obj.children.length > 0) {
                    ids = ids.concat(getAllIds(obj.children));
                }
            });

            return ids;
        };

        const findById = (arr: any[], id: number): {id: number} | undefined => {
            for (const obj of arr) {
                if (obj.item && obj.item.id === id) {
                    return obj.item;
                }

                if (obj.children && obj.children.length > 0) {
                    const found = findById(obj.children, id);
                    if (found) {
                        return found;
                    }
                }
            }

            return undefined;
        };

        for (let i = batches.length - 1; i >= 0; i--) {
            const newMonitoringData = keysFirstLetterToLowerCase(batches[i]);
            const allIds = getAllIds(newMonitoringData);
            if (!allIds.some(id => id === monitoringItem.id)) {
                continue;
            }

            const foundObject = findById(newMonitoringData, monitoringItem.id);
            if (foundObject?.id) {
                dispatch({type: GET_MONITORING, payload: foundObject});
            } else {
                dispatch(getEventMonitorToUserDetail(monitoringItem.id, jwtTokenRef.current?.jwtToken));
            }
            return;
        }
    };

    const applyDashboardHubBatches = (batches: any[][]) => {
        if (!autoReloadRef.current || !batches.length) {
            return;
        }

        const tracker = dashboardTrackerRef.current;
        if (!tracker) {
            batchesDuringDashboardRef.current.push(...batches);
            return;
        }

        const current = monitoringDashboardRef.current;
        if (!current) {
            return;
        }

        const next = applyMonitoringDashboardHubBatches(
            current,
            batches,
            tracker,
            monitoringFilterDataRef.current?.filter
        );

        if (next === current) {
            return;
        }

        monitoringDashboardRef.current = next;
        dispatch({type: GET_MONITORING_DASHBOARD, payload: next});
    };

    const flushHubEvents = () => {
        hubFlushScheduledRef.current = false;
        const queued = hubEventQueueRef.current;
        if (!queued.length) {
            return;
        }

        hubEventQueueRef.current = [];
        setAllStatuses(queued[queued.length - 1]);
        updateOpenedMonitoringDetails(queued);
        applyDashboardHubBatches(queued);

        if (!autoReloadRef.current || paginationPageRef.current !== 1 || restInFlightRef.current) {
            return;
        }

        const nextList = applyMonitoringHubBatches(
            monitoringListRef.current || [],
            queued,
            monitoringFilterDataRef.current?.filter,
            paginationSizeRef.current
        );

        monitoringListRef.current = nextList;
        dispatch({type: GET_MONITORINGS, payload: nextList});
    };

    const enqueueHubEvent = (raw: any) => {
        const parsed = parseMonitoringHubPayload(raw);
        if (!parsed) {
            return;
        }

        hubEventQueueRef.current.push(parsed);

        if (restInFlightRef.current) {
            batchesDuringRestRef.current.push(parsed);
        }

        if (!hubFlushScheduledRef.current) {
            hubFlushScheduledRef.current = true;
            queueMicrotask(flushHubEvents);
        }
    };

    enqueueHubEventRef.current = enqueueHubEvent;

    const replayHubBatchesAfterRest = (items: any) => {
        const pending = batchesDuringRestRef.current;
        batchesDuringRestRef.current = [];

        const canApplyHub = autoReloadRef.current && paginationPageRef.current === 1;
        if (!pending.length || !canApplyHub) {
            if (Array.isArray(items)) {
                monitoringListRef.current = items;
            }
            return;
        }

        const baseList = Array.isArray(items) ? items : (monitoringListRef.current || []);
        const nextList = applyMonitoringHubBatches(
            baseList,
            pending,
            monitoringFilterDataRef.current?.filter,
            paginationSizeRef.current
        );

        monitoringListRef.current = nextList;
        dispatch({type: GET_MONITORINGS, payload: nextList});
    };

    const requestMonitoringDashboard = (dashboardPayload: {filter: any[]; userName: string}) => {
        const requestId = ++dashboardRequestIdRef.current;
        dashboardTrackerRef.current = null;
        batchesDuringDashboardRef.current = [];

        Promise.resolve(dispatch(getMonitoringDashboard(dashboardPayload, jwtTokenRef.current?.jwtToken)))
            .then((snapshot: any) => {
                if (dashboardRequestIdRef.current !== requestId) {
                    return;
                }

                const pending = batchesDuringDashboardRef.current;
                batchesDuringDashboardRef.current = [];

                if (!snapshot?.snapshotTimeMs) {
                    return;
                }

                monitoringDashboardRef.current = snapshot.dashboard;
                dashboardTrackerRef.current = createMonitoringDashboardTracker(
                    snapshot.snapshotTimeMs,
                    snapshot.dashboard
                );
                applyDashboardHubBatches(pending);
            })
            .catch(() => {
                if (dashboardRequestIdRef.current === requestId) {
                    batchesDuringDashboardRef.current = [];
                }
            });
    };

    const requestMonitoringList = (dataSort: any, options?: {forceDashboard?: boolean}) => {
        restInFlightRef.current = true;
        batchesDuringRestRef.current = [];
        const requestId = ++restRequestIdRef.current;

        const dashboardPayload = {
            filter: dataSort?.filter || [],
            userName: dataSort?.username || dataSort?.userName || user?.userName || ''
        };
        const dashboardRequestKey = JSON.stringify(dashboardPayload);
        if (options?.forceDashboard || prevDashboardRequestRef.current !== dashboardRequestKey) {
            prevDashboardRequestRef.current = dashboardRequestKey;
            requestMonitoringDashboard(dashboardPayload);
        }

        Promise.resolve(dispatch(getMonitoringWithPaginationFilterAndSorting(dataSort, jwtTokenRef.current?.jwtToken)))
            .then((items: any) => {
                if (restRequestIdRef.current !== requestId) {
                    return;
                }

                replayHubBatchesAfterRest(items);
                restInFlightRef.current = false;
                batchesDuringRestRef.current = [];

                if (hubEventQueueRef.current.length && !hubFlushScheduledRef.current) {
                    hubFlushScheduledRef.current = true;
                    queueMicrotask(flushHubEvents);
                }
            })
            .catch(() => {
                if (restRequestIdRef.current !== requestId) {
                    return;
                }

                replayHubBatchesAfterRest(undefined);
                restInFlightRef.current = false;
                batchesDuringRestRef.current = [];

                if (hubEventQueueRef.current.length && !hubFlushScheduledRef.current) {
                    hubFlushScheduledRef.current = true;
                    queueMicrotask(flushHubEvents);
                }
            });
    };

    useEffect(() => {
        if (!reconnectSession && autoReload) {
            const connection = startConnection(jwtToken?.jwtToken || "");
            connectionRef.current = connection;

            return () => {
                try {
                    connection?.off?.('MonitorUserFirstEvent');
                    connection?.off?.('MonitorUserEvent');
                } catch {}
                connection.stop();
                unregisterHubConnection(connection);
            };
        } else if (!autoReload && monitoringHubConnection) {
            try {
                monitoringHubConnection?.off?.('MonitorUserFirstEvent');
                monitoringHubConnection?.off?.('MonitorUserEvent');
            } catch {}
            monitoringHubConnection.stop();
            unregisterHubConnection(monitoringHubConnection);
            setMonitoringHubConnection(null);
            connectionRef.current = null;
        }
    }, [reconnectSession, jwtToken?.jwtToken, autoReload]);

    useEffect(() => {
        if (isOnline && !monitoringHubConnection && !connectionRef.current && autoReload) {
            const connection = startConnection(jwtToken?.jwtToken || "");
            connectionRef.current = connection;
        }
    }, [isOnline, jwtToken?.jwtToken, autoReload]);

    useEffect(() => {
        const intervalId = setInterval(() => {
            if (!autoReload) {
                dispatch(setMonitoringHubError(false));
                return;
            }

            const state = monitoringHubConnection?.state;
            const isConnectedOrConnecting = state === 'Connecting' || state === 'Connected';

            dispatch(setMonitoringHubError(!(isOnline && isConnectedOrConnecting)));

            if (isOnline && (state === 'Disconnected' || !monitoringHubConnection) && !connectionRef.current) {
                const now = Date.now();
                const timeSinceLastAttempt = now - lastReconnectionTimeRef.current;

                let shouldAttempt = false;
                let interval = 5000;

                if (reconnectionAttemptsRef.current < 3) {
                    shouldAttempt = timeSinceLastAttempt >= 5000;
                    interval = 5000;
                } else {
                    shouldAttempt = timeSinceLastAttempt >= 30000;
                    interval = 30000;
                }

                if (shouldAttempt) {
                    reconnectionAttemptsRef.current++;
                    lastReconnectionTimeRef.current = now;
                    const connection = startConnection(jwtToken?.jwtToken || "");
                    connectionRef.current = connection;
                }
            }
        }, 5000);

        return () => clearInterval(intervalId);
    }, [monitoringHubConnection, isOnline, autoReload]);

    useEffect(() => {
        if (allStatuses && !allStatuses.SessionId && allStatuses.length) {
            if (monitoringData?.id) {
                const foundCallDetail = allStatuses?.find((callDetail: { Id: any; }) => callDetail.Id === monitoringData?.id);
                if (foundCallDetail) {
                    const foundCallDetailId = foundCallDetail?.Id;
                    if (foundCallDetailId !== undefined) {
                        dispatch(getEventMonitorToUserDetail(foundCallDetailId, jwtToken?.jwtToken));
                    }
                }
            }
        }
    }, [allStatuses]);

    useEffect(() => {
        if (allStatuses && allStatuses?.length) {
            let newMonitoringData = keysFirstLetterToLowerCase(allStatuses);
            const getAllObjectByNameTo = (arr: any[]): any[] => {
                let ids: any[] = [];

                arr.forEach(obj => {
                    if (obj.item && obj.item.aNI) {
                        ids.push(obj.item.aNI);
                    }

                    if (obj.children && obj.children.length > 0) {
                        ids = ids.concat(getAllObjectByNameTo(obj.children));
                    }
                });

                return ids;
            };

            const getAllObjectByAni = (arr: any[]): any[] => {
                let ids: any[] = [];

                arr.forEach(obj => {
                    if (obj.item && obj.item.aNI) {
                        ids.push(obj.item.aNI);
                    }

                    if (obj.children && obj.children.length > 0) {
                        ids = ids.concat(getAllObjectByAni(obj.children));
                    }
                });

                return ids;
            };

            const getAllObjectByUsername = (arr: any[]): any[] => {
                let ids: any[] = [];

                arr.forEach(obj => {
                    if (obj.item && obj.item.userName) {
                        ids.push(obj.item.userName);
                    }

                    if (obj.children && obj.children.length > 0) {
                        ids = ids.concat(getAllObjectByUsername(obj.children));
                    }
                });

                return ids;
            };

            let allNameTo = getAllObjectByNameTo(newMonitoringData);
            let allUsername = getAllObjectByUsername(newMonitoringData);
            let allANI = getAllObjectByAni(newMonitoringData);

            const foundNameTo = allNameTo.find(nameTo => nameTo === user.userName);
            const foundUsername = allUsername.find(username => username === user.userName);
            const foundAni = allANI.find(username => username === user.userName);

            if (foundNameTo || foundUsername || foundAni) {
                const findObject = (arr: any[], userName: any): any | undefined => {
                    for (const obj of arr) {
                        if (obj.item && (obj.item.aNI === user.userName || obj.item.userName === user.userName || obj.item.aNI === user.userName)) {
                            return obj.item;
                        }

                        if (obj.children && obj.children.length > 0) {
                            const found = findObject(obj.children, userName);
                            if (found) {
                                return found;
                            }
                        }
                    }

                    return undefined;
                };

                const foundObject = findObject(newMonitoringData, user?.userName);

                if (foundObject?.status === 101) {
                    // setSelectedRowData(foundObject);
                    // setVisible(true);
                    // dispatch({type: GET_MONITORING_FOR_SIP, payload: foundObject});
                }
            }
        }
    }, [allStatuses]);

    const resetTableHorizontalScroll = () => {
        const scrollableBody = document.querySelector('.p-datatable-wrapper');
        if (scrollableBody) {
            scrollableBody.scrollTop = 0;
            scrollableBody.scrollLeft = 0;
        }
    };

    useEffect(() => {
        if (!userSortFields?.userId && jwtToken?.jwtToken) {
            dispatch(getUserSortFields(jwtToken.jwtToken));
        }
    }, [userSortFields?.userId, jwtToken?.jwtToken]);

    useEffect(() => {
        if (pagination.hasNext && pagination.pageNumber) {
            setTotalItems((pagination.pageNumber * paginationSize) + paginationSize)
        } else if (!pagination.hasNext) {
            setTotalItems(pagination.pageNumber * paginationSize);
        }
    }, [pagination]);

    useEffect(() => {
        setTotalItems((pagination.pageNumber * paginationSize) + paginationSize);
    }, []);


    useEffect(() => {
        setFirst(0);
    }, [pageChanged])

    const renderTableColumns = (caseFn: (name: string, i: number) => any) => {
        return activeColumns
            .map((col: { name: string }, i: number) => caseFn(col.name, i))
            .filter(Boolean);
    };

    const createUuidv4 = () => {
        return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
            // @ts-ignore
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    }

    const formatDateTime = (dateString: any) => {
        const date = new Date(dateString);
        return `${date.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit', second: '2-digit'})} ${date.toLocaleDateString('en-GB')}`;
    };

    const formatItem = (item: { start: any; }) => {
        if (item && item.start) {
            return {
                ...item,
                start: formatDateTime(item.start),
                dateTime: createUuidv4()
            };
        }
        return item;
    };

    const formatDataRecursively = (obj: any) => {
        const formattedObj = {
            ...obj,
            item: formatItem(obj.item),
        };

        if (formattedObj.children && formattedObj.children.length > 0) {
            formattedObj.children = formattedObj.children.map((child: any) => formatDataRecursively(child));
        }

        return formattedObj;
    };

    const formattedData = monitoringList?.map(formatDataRecursively);

    useEffect(() => {
        handleResetPlayer();
    }, [selectedRowData]);

    const handleReset = () => {
        dataTableRef?.current?.reset();
        dispatch(resetAllMonitoringFilters());
        customFilter();
        setStartTime(null);
        setEndTime(null);
        setFilterEndDateTime(null);
        setStartFinishTime(null);
        setEndFinishTime(null);
        setFilterFinishDateTime(null);
        setFilterFinishEndDateTime(null);
        setSortOrder(0);
        setFirst(0);
        dispatch(setCurrentPage(1));
        dispatch(setCurrentPageSize(10));
        setReactionClient(false);
        setReactionOperator(false);
        setFullCallDuration(false);
        setDuration(false);
        setReactionOperatorStartTime(getDefaultStartTime());
        setReactionOperatorEndTime(getDefaultStartTime());
        setReactionOperator(false);
        setDurationStartTime(getDefaultStartTime());
        setDurationEndTime(getDefaultStartTime());
        setfullCallDurationStartTime(getDefaultStartTime());
        setfullCallDurationEndTime(getDefaultStartTime());
        setReactionClientStartTime(getDefaultStartTime());
        setReactionClientEndTime(getDefaultStartTime());
        setReactionClient(false);
        setActivity(false);
        setHasStartFilter(false);
        setHasEndFilter(false);
        setFilterFullName(null);
        skipUrlWriteRef.current = true;
        setSearchParams(new URLSearchParams(), {replace: true});
    };

    useEffect(() => {
        dispatch(getCampaignFilterList(jwtToken?.jwtToken));
        if (hasBranchAccess && jwtToken?.jwtToken) {
            dispatch(getUsersManagerUserBranchesData(jwtToken.jwtToken));
        }
    }, [dispatch, hasBranchAccess, jwtToken?.jwtToken]);

    useEffect(() => {
        if (!initialMonitoringUrlState.hasAny) return;
        if (Object.keys(initialMonitoringUrlState.uiFilters || {}).length > 0) {
            dispatch(setMonitoringUiFilters(initialMonitoringUrlState.uiFilters));
        }
    }, []);

    useEffect(() => {
        return () => {
            dashboardRequestIdRef.current += 1;
            dashboardTrackerRef.current = null;
            batchesDuringDashboardRef.current = [];
            dispatch(clearMonitoringDashboard());
        };
    }, [dispatch]);

    useEffect(() => {
        const wasAutoReload = prevAutoReloadRef.current;
        prevAutoReloadRef.current = autoReload;

        if (wasAutoReload === autoReload) {
            return;
        }

        dashboardRequestIdRef.current += 1;
        dashboardTrackerRef.current = null;
        batchesDuringDashboardRef.current = [];

        if (autoReload) {
            requestMonitoringList(sortData, {forceDashboard: true});
        }
    }, [autoReload]);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const onPageChange = (event: { first: React.SetStateAction<number>; page: number; rows: any; }) => {
        setFirst(event.first);
        dispatch(setCurrentPage(event.page + 1));
        dispatch(setCurrentPageSize(event.rows));
        setSortData((prev: any) => ({...prev, pageNumber: event.page + 1, pageSize: event.rows}));
    };

    const formatDate = (dateString: Date) => {
        const dateObj = new Date(dateString);

        const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
        const day = dateObj.getDate().toString().padStart(2, "0");
        const year = dateObj.getFullYear();

        return `${month}/${day}/${year}`;
    };

    const getTime = (dateString: Date) => {
        const dateObj = new Date(dateString);
        const hours = dateObj.getHours().toString().padStart(2, "0");
        const minutes = dateObj.getMinutes().toString().padStart(2, "0");
        const seconds = dateObj.getSeconds().toString().padStart(2, "0");

        return `${hours}:${minutes}:${seconds}`;
    };

    const getTimeWithoutSecond = (dateString: Date) => {
        const dateObj = new Date(dateString);
        const hours = dateObj.getHours().toString().padStart(2, "0");
        const minutes = dateObj.getMinutes().toString().padStart(2, "0");

        return `${hours}:${minutes}`;
    };


    useEffect(() => {
        if (!hasInitializedPagination.current) {
            hasInitializedPagination.current = true;
            const urlPage = initialMonitoringUrlState.page || 1;
            const urlSize = initialMonitoringUrlState.size || 10;
            const pageChanged = paginationPage !== urlPage;
            const sizeChanged = paginationSize !== urlSize;
            if (pageChanged) {
                dispatch(setCurrentPage(urlPage));
            }
            if (sizeChanged) {
                dispatch(setCurrentPageSize(urlSize));
            }
            // If Redux already has the URL page/size, continue and fetch now.
            // Otherwise wait for the pagination dispatch to re-run this effect.
            if (pageChanged || sizeChanged) {
                return;
            }
        }

        let filter: {
            key: string;
            value: string
        }[] = [];

        let startAdded = false;
        let endAdded = false;

        const dataSort: any = {
            pageNumber: paginationPage,
            pageSize: paginationSize,
            sort: {
                orderBy: orderBy ? orderBy : "Id",
                isDesc: isDescFilter
            },
            username: user.userName
        }

        if (filterCampaignId?.value) {
            filter.push(filterCampaignId);
        }
        if (filterNameTo?.value) {
            filter.push(filterNameTo);
        }
        if (filterANumber?.value) {
            filter.push(filterANumber);
        }
        if (filterNameFrom?.value) {
            filter.push(filterNameFrom);
        }
        if (filterTypeChannel) {
            filterTypeChannel?.map((item: any) => {
                if (item.value === 'internalSkipped') {
                    filter.push({key: 'IsDeclined', value: '1'});
                } else {
                    filter.push(item);
                }
            })
        }

        if (filterCampaignName) {
            filterCampaignName?.map((item: any) => {
                filter.push(item);
            })
        }

        if (filterBranchName) {
            filterBranchName?.map((item: any) => {
                filter.push(item);
            })
        }

        if (filterCallOwner) {
            filterCallOwner?.map((item: any) => {
                filter.push(item);
            })
        }

        if (filterOwnerType) {
            filterOwnerType?.map((item: any) => {
                filter.push(item);
            })
        }

        if (filterQueueName) {
            filterQueueName?.map((item: any) => {
                filter.push(item);
            })
        }

        if (filterFullName) {
            filterFullName?.map((item: any) => {
                filter.push(item);
            })
        }

        if (filterStatus) {
            filterStatus.map((item: any) => {
                filter.push(item);
            })
        }
        if (filterDirection) {
            filterDirection.map((item: any) => {
                filter.push(item);
            })
        }
        if (filterAmdHangup) {
            filterAmdHangup.map((item: any) => {
                filter.push(item);
            })
        }
        if (filterCallReset) {
            filterCallReset.map((item: any) => {
                filter.push(item);
            })
        }
        if ((filterDateTime && filterEndDateTime) || hasStartFilter) {
            let startDate = formatDate(filterDateTime || getDefaultStartDate());
            let endDate = formatDate(filterEndDateTime || getDefaultEndDate());

            if ((startTime && endTime) || hasStartFilter) {
                let filterStartTime = getTime(startTime || getDefaultStartTime());
                let filterEndTime = getTime(endTime || getDefaultEndTime());
                filter.push({
                    "key": "Start",
                    "value": `${startDate} ${filterStartTime},${endDate} ${filterEndTime}`
                });
                startAdded = true;
            }
        }

        if ((filterFinishDateTime && filterFinishEndDateTime) || hasEndFilter) {
            let startDate = formatDate(filterFinishDateTime || getDefaultStartDate());
            let endDate = formatDate(filterFinishEndDateTime || getDefaultEndDate());

            if ((startFinishTime && endFinishTime) || hasEndFilter) {
                let filterStartTime = getTime(startFinishTime || getDefaultStartTime());
                let filterEndTime = getTime(endFinishTime || getDefaultEndTime());
                filter.push({
                    "key": "End",
                    "value": `${startDate} ${filterStartTime},${endDate} ${filterEndTime}`
                });
                endAdded = true;
            }
        }

        const addFilterSecond = (condition: boolean, key: string, startTime: number, endTime: number) => {
            if (
                condition &&
                startTime !== undefined && startTime !== null &&
                endTime !== undefined && endTime !== null
            ) {
                filter.push({
                    "key": key,
                    "value": `${startTime}, ${endTime}`
                });
            }
        };

        const getTotalSeconds = (date: any) => {
            if (!date) return null;
            const hours = date.getHours();
            const minutes = date.getMinutes();
            const seconds = date.getSeconds();
            return hours * 3600 + minutes * 60 + seconds;
        };


        if (reactionClient && reactionClientStartTime && reactionClientEndTime) {
            addFilterSecond(reactionClient, "ReactionClient", getTotalSeconds(reactionClientStartTime), getTotalSeconds(reactionClientEndTime));
        }
        if (reactionOperator && reactionOperatorStartTime && reactionOperatorEndTime) {
            addFilterSecond(reactionOperator, "ReactionOperator", getTotalSeconds(reactionOperatorStartTime), getTotalSeconds(reactionOperatorEndTime));
        }
        if (fullCallDuration && fullCallDurationStartTime && fullCallDurationEndTime) {
            addFilterSecond(fullCallDuration, "FullCallDuration", getTotalSeconds(fullCallDurationStartTime), getTotalSeconds(fullCallDurationEndTime));
        }
        if (duration && durationStartTime && durationEndTime) {
            addFilterSecond(duration, "Duration", getTotalSeconds(durationStartTime), getTotalSeconds(durationEndTime));
        }

        if (filter) {
            dataSort['filter'] = filter;
        }

        const currentFilters = filter || [];
        const savedFilters = monitoringFilterData?.filter || [];
        const allFilters = [...currentFilters, ...savedFilters];

        const hasDurationFilter = allFilters.some((f: any) => f.key === "Duration");
        const hasFullCallDurationFilter = allFilters.some((f: any) => f.key === "FullCallDuration");
        const hasReactionClientFilter = allFilters.some((f: any) => f.key === "ReactionClient");
        const hasReactionOperatorFilter = allFilters.some((f: any) => f.key === "ReactionOperator");

        if (hasDurationFilter) setDuration(true);
        if (hasFullCallDurationFilter) setFullCallDuration(true);
        if (hasReactionClientFilter) setReactionClient(true);
        if (hasReactionOperatorFilter) setReactionOperator(true);

        if (isFirstRun.current) {
            isFirstRun.current = false;
            prevDataSortRef.current = dataSort;
        } else {
            const prevDataSort = prevDataSortRef.current;
            const hasChanged = JSON.stringify(prevDataSort) !== JSON.stringify(dataSort);

            if (!hasChanged) return;

            prevDataSortRef.current = dataSort;
        }

        collapseAll();
        requestMonitoringList(dataSort);
        dispatch(setMonitoringFilter(dataSort));
        setSortData(dataSort);
        resetTableHorizontalScroll();
    }, [paginationPage, paginationSize, orderBy, isDescFilter, sortOrder, filterCampaignId, filterBranchName, filterNameTo, filterANumber, filterNameFrom, filterTypeChannel, filterStatus, filterCampaignName, filterCallOwner, filterOwnerType, filterQueueName, filterFullName, filterDirection, filterAmdHangup, filterCallReset, reactionClient, reactionOperator, duration, fullCallDuration, monitoringFilterData, hasEndFilter, hasStartFilter]);

    useEffect(() => {
        if (skipUrlWriteRef.current) {
            skipUrlWriteRef.current = false;
            return;
        }

        const nextParams = buildMonitoringSearchParams({
            page: paginationPage,
            size: paginationSize,
            orderBy,
            isDesc: isDescFilter,
            sortOrder,
            filterCampaignId,
            filterNameTo,
            filterANumber,
            filterNameFrom,
            filterTypeChannel,
            filterOwnerType,
            filterFullName,
            filterCampaignName,
            filterBranchName,
            filterCallOwner,
            filterQueueName,
            filterDirection,
            filterStatus,
            filterAmdHangup,
            filterCallReset,
            filterDateTime,
            filterEndDateTime,
            startTime,
            endTime,
            hasStartFilter,
            filterFinishDateTime,
            filterFinishEndDateTime,
            startFinishTime,
            endFinishTime,
            hasEndFilter,
            duration,
            durationStartTime,
            durationEndTime,
            fullCallDuration,
            fullCallDurationStartTime,
            fullCallDurationEndTime,
            reactionClient,
            reactionClientStartTime,
            reactionClientEndTime,
            reactionOperator,
            reactionOperatorStartTime,
            reactionOperatorEndTime,
        });

        if (!areSearchParamsEqual(searchParams, nextParams)) {
            setSearchParams(nextParams, {replace: true});
        }
    }, [
        paginationPage, paginationSize, orderBy, isDescFilter, sortOrder,
        filterCampaignId, filterNameTo, filterANumber, filterNameFrom,
        filterTypeChannel, filterOwnerType, filterFullName, filterCampaignName,
        filterBranchName, filterCallOwner, filterQueueName, filterDirection,
        filterStatus, filterAmdHangup, filterCallReset,
        filterDateTime, filterEndDateTime, startTime, endTime, hasStartFilter,
        filterFinishDateTime, filterFinishEndDateTime, startFinishTime, endFinishTime, hasEndFilter,
        duration, durationStartTime, durationEndTime,
        fullCallDuration, fullCallDurationStartTime, fullCallDurationEndTime,
        reactionClient, reactionClientStartTime, reactionClientEndTime,
        reactionOperator, reactionOperatorStartTime, reactionOperatorEndTime,
        searchParams, setSearchParams
    ]);

    useEffect(() => {
        if (monitoringFilterData?.filter) {
            const savedFilters = monitoringFilterData.filter;

            const hasDurationFilter = savedFilters.some((f: any) => f.key === "Duration");
            const hasFullCallDurationFilter = savedFilters.some((f: any) => f.key === "FullCallDuration");
            const hasReactionClientFilter = savedFilters.some((f: any) => f.key === "ReactionClient");
            const hasReactionOperatorFilter = savedFilters.some((f: any) => f.key === "ReactionOperator");

            if (hasDurationFilter) setDuration(true);
            if (hasFullCallDurationFilter) setFullCallDuration(true);
            if (hasReactionClientFilter) setReactionClient(true);
            if (hasReactionOperatorFilter) setReactionOperator(true);
        }
    }, [monitoringFilterData]);

    useEffect(() => {
        if (activeClick?.item === "/monitoring" && getHashPath(activeClick?.from) === '#/monitoring') {
            requestMonitoringList(sortData, {forceDashboard: true});
            resetTableHorizontalScroll();
        }
    }, [activeClick]);

    const monitoringSort = (event: { sortField: any; }) => {
        const handleAction = (sortField: string) => {
            let newOrderBy: string;

            switch (sortField) {
                case 'item.userName':
                    newOrderBy = 'UserName';
                    break;
                case 'item.callType':
                    newOrderBy = 'CallType';
                    break;
                case 'item.start':
                    newOrderBy = 'Start';
                    break;
                case 'item.status':
                    newOrderBy = 'Status';
                    break;
                case 'item.ani':
                    newOrderBy = 'Ani';
                    break;
                case 'item.aNumber':
                    newOrderBy = 'ANumber';
                    break;
                case 'item.campaignName':
                    newOrderBy = 'CampaignName';
                    break;
                case 'item.campaignId':
                    newOrderBy = 'CampaignId';
                    break;
                case 'BranchId':
                case 'item.branchId':
                    newOrderBy = 'BranchId';
                    break;
                case 'item.callReset':
                    newOrderBy = 'CallReset';
                    break;
                case 'forcedClosing':
                    newOrderBy = 'ForcedClosing';
                    break;
                case 'item.fullName':
                    newOrderBy = 'UserName';
                    break;
                case 'item.direction':
                    newOrderBy = 'Direction';
                    break;
                case 'item.queueId':
                    newOrderBy = 'QueueId';
                    break;
                case 'item.ownerUserName':
                    newOrderBy = 'OwnerUserName';
                    break;
                case 'FullCallDuration':
                    newOrderBy = 'FullCallDuration';
                    break;
                case 'Duration':
                    newOrderBy = 'Duration';
                    break;
                case 'ReactionOperator':
                    newOrderBy = 'ReactionOperator';
                    break;
                case 'ReactionClient':
                    newOrderBy = 'ReactionClient';
                    break;
                case 'End':
                    newOrderBy = 'End';
                    break;
                case 'OwnerType':
                    newOrderBy = 'OwnerType';
                    break;
                case 'ANumber':
                    newOrderBy = 'ANumber';
                    break;
                default:
                    return;
            }

            setOrderBy(newOrderBy);
            setIsDescFilter(!isDescFilter);
            setSortOrder(sortOrder === 1 ? -1 : 1);
            dispatch(setCurrentPage(1));
            setFirst(0);
        };
        let sortField = event.sortField;
        handleAction(sortField);
    };

    const filterClearTemplate = (options: { filterClearCallback: React.MouseEventHandler<HTMLButtonElement> | undefined; field: string }) => {
        return <Button type="button" className="p-button-secondary" icon="pi pi-times" onClick={(e) => {
            if (options.filterClearCallback) {
                options.filterClearCallback(e);
            }
            if (options.field === 'start') {
                setStartTime(null);
                setEndTime(null);
                setFilterDateTime(null);
                setFilterEndDateTime(null);
            }
            if (options.field === 'end') {
                setStartFinishTime(null);
                setEndFinishTime(null);
                setFilterFinishDateTime(null);
                setFilterFinishEndDateTime(null);
            }
            if (options.field === 'reactionClient') {
                setReactionClientStartTime(null);
                setReactionClientEndTime(null);
                setReactionClient(false);
            }
            if (options.field === 'reactionOperator') {
                setReactionOperatorStartTime(null);
                setReactionOperatorEndTime(null);
                setReactionOperator(false);
            }
            if (options.field === 'duration') {
                setDuration(false);
                setDurationStartTime(null);
                setDurationEndTime(null);
            }
            if (options.field === 'fullCallDuration') {
                setfullCallDurationStartTime(null);
                setfullCallDurationEndTime(null);
                setFullCallDuration(false);
            }
        }}></Button>;
    }

    const filterApplyTemplate = (options: {
        filterApplyCallback: React.MouseEventHandler<HTMLButtonElement> | undefined;
        field: string;
    }) => {
        const handleClick = () => {
            if (options.field === 'start') {
                if (!filterDateTime) setFilterDateTime(getDefaultStartDate());
                if (!filterEndDateTime) setFilterEndDateTime(getDefaultEndDate());
                if (!startTime) setStartTime(getDefaultStartTime());
                if (!endTime) setEndTime(getDefaultEndTime());

                setHasStartFilter(true);

                // Применяем фильтр программно через ref
                if (dataTableRef.current) {
                    const filterValue = startTime || getDefaultStartTime();
                    dataTableRef.current.filter(filterValue, 'start', 'contains');
                }
            }

            if (options.field === 'end') {
                if (!startFinishTime) setStartFinishTime(getDefaultStartTime());
                if (!endFinishTime) setEndFinishTime(getDefaultEndTime());

                setHasEndFilter(true);

                // Применяем фильтр программно через ref
                if (dataTableRef.current) {
                    const filterValue = endFinishTime || getDefaultEndTime();
                    dataTableRef.current.filter(filterValue, 'end', 'contains');
                }
            }

            if (options.field === 'reactionClient') {
                if (!reactionClientStartTime) setReactionClientStartTime(getDefaultStartTime());
                setReactionClient(true);

                // Применяем фильтр программно через ref
                if (dataTableRef.current) {
                    const filterValue = reactionClientStartTime || getDefaultStartTime();
                    dataTableRef.current.filter(filterValue, 'reactionClient', 'contains');
                }
            }

            if (options.field === 'reactionOperator') {
                if (!reactionOperatorStartTime) setReactionOperatorStartTime(getDefaultStartTime());
                setReactionOperator(true);

                // Применяем фильтр программно через ref
                if (dataTableRef.current) {
                    const filterValue = reactionOperatorStartTime || getDefaultStartTime();
                    dataTableRef.current.filter(filterValue, 'reactionOperator', 'contains');
                }
            }

            if (options.field === 'fullCallDuration') {
                if (!fullCallDurationStartTime) setfullCallDurationStartTime(getDefaultStartTime());
                setFullCallDuration(true);

                // Применяем фильтр программно через ref
                if (dataTableRef.current) {
                    const filterValue = fullCallDurationStartTime || getDefaultStartTime();
                    dataTableRef.current.filter(filterValue, 'fullCallDuration', 'contains');
                }
            }

            if (options.field === 'duration') {
                if (!durationStartTime) setDurationStartTime(getDefaultStartTime());
                setDuration(true);

                // Применяем фильтр программно через ref
                if (dataTableRef.current) {
                    const filterValue = durationStartTime || getDefaultStartTime();
                    dataTableRef.current.filter(filterValue, 'duration', 'contains');
                }
            }

            if (options.filterApplyCallback) {
                options.filterApplyCallback({} as any);
            }
        };

        const isTimeValid = (startTime: Date | null | false, endTime: Date | null | false): boolean => {
            if (!startTime || !endTime) return true;
            return endTime.getTime() > startTime.getTime();
        };

        return <Button type="button" icon="pi pi-check" onClick={handleClick} className=""
                       disabled={
                           (options.field === 'duration' && (!durationEndTime || !isTimeValid(durationStartTime, durationEndTime))) ||
                           (options.field === 'fullCallDuration' && (!fullCallDurationEndTime || !isTimeValid(fullCallDurationStartTime, fullCallDurationEndTime))) ||
                           (options.field === 'reactionOperator' && (!reactionOperatorEndTime || !isTimeValid(reactionOperatorStartTime, reactionOperatorEndTime))) ||
                           (options.field === 'reactionClient' && (!reactionClientEndTime || !isTimeValid(reactionClientStartTime, reactionClientEndTime)))
                       }></Button>
    }

    useEffect(() => {
        if (hasUsersAccess) {
            dispatch(getAllSimpleUsers(jwtToken?.jwtToken));
        }
    }, [hasUsersAccess]);

    const updateFilter = (field: string, value: any) => {
        dispatch(updateMonitoringFilter(field, value));
    };

    // useEffect(() => {
    //     if (activity) {
    //         updateFilter('fullName', [`${user?.userName}`]);
    //     } else {
    //         updateFilter('fullName', null);
    //     }
    // }, [activity]);

    const activityChangedManuallyRef = useRef(false);


    useEffect(() => {
        if (activityChangedManuallyRef.current) {
            activityChangedManuallyRef.current = false;

            if (activity) {
                updateFilter('fullName', [`${user?.userName}`]);
            } else {
                updateFilter('fullName', null);
            }
        }
    }, [activity, user?.userName]);

    useEffect(() => {
        if (!filterFullName || filterFullName.length !== 1) {
            if (activity) {
                setActivity(false);
            }
            return;
        }

        const onlyItem = filterFullName[0];

        if (onlyItem.value === user?.userName) {
            if (!activity) {
                setActivity(true);
            }
        } else {
            if (activity) {
                setActivity(false);
            }
        }
    }, [filterFullName, user?.userName]);



    useEffect(() => {
        if (clearFilters) {
            if (pendingUrlFilterSkipsRef.current > 0) {
                pendingUrlFilterSkipsRef.current -= 1;
                return;
            }
            customFilter({ filters: clearFilters });
        }
    }, [clearFilters]);

    const customFilter = (event?: any) => {
        if (event) {
            const filters = event.filters;
            const {start} = event.filters;
            const {end} = event.filters;

            setFirst(0);
            dispatch(setStatisticsCurrentPage(1));

            setFilterDateTime(start.value || null);
            setFilterFinishDateTime(end.value || null);

            // Убираем автоматическую установку флагов фильтров времени
            // setFullCallDuration(!!(fullCallDurationStartTime || fullCallDurationEndTime));
            // setDuration(!!(durationStartTime || durationEndTime));

            // Убираем автоматическую установку флагов для реакций
            // if (reactionClientStartTime || reactionClientEndTime) {
            //     setReactionClientStartTime(reactionClientStartTime || getDefaultStartTime());
            //     setReactionClientEndTime(reactionClientEndTime);
            //     setReactionClient(true);
            // } else {
            //     setReactionClient(false);
            // }

            // if (reactionOperatorStartTime || reactionOperatorEndTime) {
            //     setReactionOperatorStartTime(reactionOperatorStartTime || getDefaultStartTime());
            //     setReactionOperatorEndTime(reactionOperatorEndTime);
            //     setReactionOperator(true);
            // } else {
            //     setReactionOperator(false);
            // }
            const setFilter = (filterName: string, key: string, defaultValue?: any | null) => {
                if (!filters[filterName]) {
                    return defaultValue;
                }

                const value = filters[filterName].value || filters[filterName].constraints?.[0]?.value;
                if (!value) {
                    return defaultValue;
                }

                if (Array?.isArray(value)) {
                    return value.map((item) => ({key, value: String(item)}));
                } else {
                    return {key, value: String(value)};
                }
            };

            setFilterCampaignId(setFilter('campaignId', 'CampaignId'));
            setFilterNameTo(() => {
                const ani = filters['ani']?.value || filters['ani']?.constraints?.[0]?.value;
                if (!ani) return null;

                const cleanedValue = ani.replace(/[()\-\s\n\t\r+,;!'"?:$%&/]/g, '');
                return { key: 'ANI', value: cleanedValue };
            });
            setFilterANumber(setFilter('aNumber', 'ANumber'));
            setFilterNameFrom(setFilter('userName', 'UserName'));
            setFilterTypeChannel(setFilter('callType', 'CallType', []));
            setFilterOwnerType(setFilter('ownerType', 'OwnerType', []));
            setFilterFullName(setFilter('fullName', 'UserName', []));
            setFilterCampaignName(setFilter('campaignFullName', 'CampaignId', []));
            setFilterBranchName(setFilter('branchId', 'BranchId', []));
            setFilterCallOwner(setFilter('ownerUserName', 'OwnerUserName', []));
            setFilterQueueName(setFilter('queueFullName', 'QueueId', []));
            setFilterDirection(setFilter('direction', 'Direction', []));
            setFilterStatus(setFilter('status', 'Status', []));
            setFilterAmdHangup(setFilter('forcedClosing', 'ForcedClosing', []));
            setFilterCallReset(setFilter('callResetName', 'CallReset', []));
        } else {
            setFilterCampaignId(null);
            setFilterANumber(null);
            setFilterFullName(null);
            setFilterNameTo(null);
            setFilterNameFrom(null);
            setFilterStatus(null);
            setFilterCampaignName(null);
            setFilterBranchName(null);
            setFilterTypeChannel(null);
            setFilterDateTime(null);
            setFilterAmdHangup(null);
            setFilterCallReset(null);
            setFilterOwnerType(null);
            setOrderBy(null);
            setIsDescFilter(true);
            setFilterDirection(null);
            setFilterQueueName(null);
            setFilterCallOwner(null);
        }
    };

    const renderHeader = (field: string, sortField: string) => {
        const sorted = sortField === orderBy;
        const sortIcon = classNames('p-sortable-column-icon', {
            'pi pi-sort-amount-up-alt': sorted && sortOrder === 1,
            'pi pi-fw pi-sort-amount-down': sorted && sortOrder === -1,
            'pi pi-fw pi-sort-alt': sortOrder === 0 || !sorted
        });

        return (
            <div className="flex align-items-center" onClick={() => monitoringSort({'sortField': sortField})}>
                {field} <i className={sortIcon}></i>
            </div>
        );
    };

    const toggleTab = (tableName: string) => {
        setSelectedRowData(null);
        setActiveTab(tableName);
    };

    const isMobile = () => {
        return windowWidth <= 1248;
    }

    const renderActivityColumn = ({item}: any) => {
        return item?.callType === 'transferInternal' && !item.isDeclined ? (
            <div className="relative">
                <i className="pi pi-reply p-2 bg-green-500 border-circle text-white"
                   style={{transform: 'rotate(90deg) scaleX(1) scaleY(-1)'}}></i>
            </div>
        ) : item?.callType === 'transferInternal' && item.isDeclined ? (
                <div className="relative">
                    <i className="pi pi-reply p-2 bg-green-500 border-circle text-white"
                       style={{transform: 'rotate(90deg) scaleX(1) scaleY(-1)'}}></i>
                    <div className="absolute" style={{top: '-5px', left: '18px'}}>
                        <div className="border-circle relative"
                             style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                            <i className="pi pi-times text-white absolute left-50 top-50 kk"
                               style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                        </div>
                    </div>
                </div>) :

            item?.callType === 'transferExternal' && !item.isDeclined ? (
                <div className="relative">
                    <i className="pi pi-reply p-2 bg-primary border-circle text-white"
                       style={{transform: 'rotate(90deg) scaleX(-1) scaleY(-1)'}}></i>
                </div>
            ) : item?.callType === 'transferInternal' && item.isDeclined ? (
                    <div className="relative">
                        <i className="pi pi-reply p-2 bg-primary border-circle text-white"
                           style={{transform: 'rotate(90deg) scaleX(-1) scaleY(-1)'}}></i>
                        <div className="absolute" style={{top: '-5px', left: '18px'}}>
                            <div className="border-circle relative"
                                 style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                            </div>
                        </div>
                    </div>)
                : item?.callType === 'callback' ? (
                    <div className="relative">
                        <i className="pi pi-undo p-2 border-circle text-white" style={{backgroundColor: "#fda610"}}></i>
                    </div>
                ) : item?.callType === 'internal' && !item.isDeclined ? (
                    <div className="relative">
                        <i className="pi pi-arrow-down-left p-2 border-circle bg-green-500 text-white"></i>
                    </div>
                ) : item?.callType === 'internal' && item.isDeclined ? (
                    <div className="relative">
                        <i className="pi pi-arrow-down-left p-2 border-circle bg-green-500 text-white"></i>
                        <div className="absolute" style={{top: '-5px', left: '18px'}}>
                            <div className="border-circle relative"
                                 style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                            </div>
                        </div>
                    </div>) : item?.callType === 'external' && !item.isDeclined ? (
                    <>
                        <i className="pi pi-arrow-up-right bg-primary p-2 border-circle text-white"></i>
                    </>
                ) : item?.callType === 'external' && item.isDeclined ? (
                    <div className="relative">
                        <i className="pi pi-arrow-up-right bg-primary p-2 border-circle text-white"></i>
                        <div className="absolute" style={{top: '-5px', left: '18px'}}>
                            <div className="border-circle relative"
                                 style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                            </div>
                        </div>
                    </div>) : item?.callType === 'ivm' && !item.isDeclined ? (
                    <>
                        <i className="bg-primary p-2 border-circle text-white font-bold relative"
                           style={{fontStyle: "normal", width: '27.99px', height: '27.99px'}}><span
                            className="absolute"
                            style={{left: '50%', top: '50%', transform: 'translate(-50%, -50%)', fontSize: '11px'}}>IVM</span></i>
                    </>
                ) : item?.callType === 'ivm' && item.isDeclined ? (
                    <div className="relative inline-block">
                        <i className="bg-primary border-circle text-white font-bold relative inline-flex align-items-center justify-content-center"
                           style={{fontStyle: "normal", width: '28px', height: '28px', minWidth: '28px', minHeight: '28px', borderRadius: '50%'}}><span
                            style={{fontSize: '11px'}}>IVM</span></i>
                        <div className="absolute" style={{top: '-3px', right: '-3px'}}>
                            <div className="border-circle relative"
                                 style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                            </div>
                        </div>
                    </div>
                ) : item?.callType === 'ivr' && !item.isDeclined ? (
                    <>
                        <i className="bg-green-500 p-2 border-circle text-white font-bold relative"
                           style={{fontStyle: "normal", width: '27.99px', height: '27.99px'}}><span
                            className="absolute"
                            style={{left: '50%', top: '50%', transform: 'translate(-50%, -50%)', fontSize: '11px'}}>IVR</span></i>
                    </>
                ) : item?.callType === 'ivr' && item.isDeclined ? (
                    <div className="relative inline-block">
                        <i className="bg-green-500 border-circle text-white font-bold relative inline-flex align-items-center justify-content-center"
                           style={{fontStyle: "normal", width: '28px', height: '28px', minWidth: '28px', minHeight: '28px', borderRadius: '50%'}}><span
                            style={{fontSize: '11px'}}>IVR</span></i>
                        <div className="absolute" style={{top: '-3px', right: '-3px'}}>
                            <div className="border-circle relative"
                                 style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                            </div>
                        </div>
                    </div>
                ) : item?.callType === 'callbackExternal' && !item.isDeclined ? (
                    <div className="relative">
                        <i className="pi pi-undo p-2 border-circle text-white"
                           style={{background: 'rgb(253, 166, 16)'}}></i>
                        <div className="absolute" style={{top: '-5px', left: '18px'}}>
                            <div className="border-circle relative bg-primary"
                                 style={{width: '14px', height: '14px'}}>
                                <i className="pi pi-arrow-up-right text-white absolute left-50 top-50 kk"
                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                            </div>
                        </div>
                    </div>) : item?.callType === 'callbackInternal' && !item.isDeclined ? (
                    <div className="relative">
                        <i className="pi pi-undo p-2 border-circle text-white"
                           style={{background: 'rgb(253, 166, 16)'}}></i>
                        <div className="absolute" style={{top: '-5px', left: '18px'}}>
                            <div className="border-circle relative bg-green-500"
                                 style={{width: '14px', height: '14px'}}>
                                <i className="pi pi-arrow-down-left text-white absolute left-50 top-50 kk"
                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                            </div>
                        </div>
                    </div>) : (item?.callType === 'callbackInternal' || item?.callType === 'callbackExternal') && item.isDeclined ? (
                    <div className="relative">
                        <i className="pi pi-undo p-2 border-circle text-white"
                           style={{background: 'rgb(253, 166, 16)'}}></i>
                        <div className="absolute" style={{top: '-5px', left: '18px'}}>
                            <div className="border-circle relative"
                                 style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                            </div>
                        </div>
                    </div>) : item?.callType === 'consultationExternal' && !item.isDeclined ? (
                    <div className="relative">
                        <i className="pi pi-users p-2 border-circle text-white"
                           style={{background: 'rgb(253, 166, 16)'}}></i>
                        <div className="absolute" style={{top: '-5px', left: '18px'}}>
                            <div className="border-circle relative bg-primary"
                                 style={{width: '14px', height: '14px'}}>
                                <i className="pi pi-arrow-up-right text-white absolute left-50 top-50 kk"
                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                            </div>
                        </div>
                    </div>
                ) : item?.callType === 'consultationInternal' && !item.isDeclined ? (
                    <div className="relative">
                        <i className="pi pi-users p-2 border-circle text-white"
                           style={{background: 'rgb(253, 166, 16)'}}></i>
                        <div className="absolute" style={{top: '-5px', left: '18px'}}>
                            <div className="border-circle relative bg-green-500"
                                 style={{width: '14px', height: '14px'}}>
                                <i className="pi pi-arrow-down-left text-white absolute left-50 top-50 kk"
                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                            </div>
                        </div>
                    </div>
                ) : (item?.callType === 'consultationInternal' || item?.callType === 'consultationExternal') && item.isDeclined ? (
                    <div className="relative">
                        <i className="pi pi-users p-2 border-circle text-white"
                           style={{background: 'rgb(253, 166, 16)'}}></i>
                        <div className="absolute" style={{top: '-5px', left: '18px'}}>
                            <div className="border-circle relative"
                                 style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                            </div>
                        </div>
                    </div>) : item?.callType === 'consultation' && !item.isDeclined ? (
                    <div className="relative">
                        <i className="pi pi-users p-2 border-circle text-white" style={{background: 'rgb(253, 166, 16)'}}></i>
                    </div>
                ) : (item?.callType === 'pickupcall') && item.isDeclined ? (
                    <div className="relative">
                        <i className="pi pi-user p-2 border-circle text-white"
                           style={{background: 'rgb(253, 166, 16)'}}></i>
                        <div className="absolute" style={{top: '-5px', left: '18px'}}>
                            <div className="border-circle relative"
                                 style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                            </div>
                        </div>
                    </div>) : item?.callType === 'pickupcall' && !item.isDeclined ? (
                    <div className="relative">
                        <i className="pi pi-user p-2 border-circle text-white" style={{background: 'rgb(253, 166, 16)'}}></i>
                    </div>
                ) : (item?.callType === 'spycall') && item.isDeclined ? (
                    <div className="relative">
                        <i className="pi pi-headphones p-2 border-circle text-white"
                           style={{background: 'rgb(253, 166, 16)'}}></i>
                        <div className="absolute" style={{top: '-5px', left: '18px'}}>
                            <div className="border-circle relative"
                                 style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                            </div>
                        </div>
                    </div>
                ) : item?.callType === 'spycall' && !item.isDeclined ? (
                    <div className="relative">
                        <i className="pi pi-headphones p-2 border-circle text-white" style={{background: 'rgb(253, 166, 16)'}}></i>
                    </div>
                ) : <></>;
    };

    const handleResetPlayer = () => {
        dispatch({type: UPLOAD_AUDIO_LOADING, payload: false});
        dispatch(setAudioUnavailable(false));
        dispatch(getAudioUrlForPlayer(null));
        setKey(key + 1);
    };

    const typeBodyTemplate = (rowData: any) => {
        return (
            <React.Fragment>
                <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">
                    {rowData.item?.ownerUserName}
                </span>
            </React.Fragment>
        );
    };

    const aniBodyTemplate = (rowData: any) => {
        return (
            <React.Fragment>
                <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">
                    {rowData.item?.ani || rowData.item?.aNI}
                </span>
            </React.Fragment>
        );
    };

    const aNumberBodyTemplate = (rowData: any) => {
        return (
            <React.Fragment>
                <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">
                    {rowData.item?.aNumber || rowData.item?.aNumber}
                </span>
            </React.Fragment>
        );
    };

    const typeOperatorTemplate = (rowData: any) => {
        return (
            <React.Fragment>
                <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">
                    {rowData.item?.fullName}
                </span>
            </React.Fragment>
        );
    };


    const typeDirectionBodyTemplate = (rowData: DataRow) => {
        return (
            <React.Fragment>
                <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">
                    {rowData.item?.direction}
                </span>
            </React.Fragment>
        );
    };

    const campaignBodyTemplate = (rowData: DataRow) => {
        return (
            <React.Fragment>
                <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">
                    {rowData.item?.campaignFullName}
                </span>
            </React.Fragment>
        );
    };

    const queueBodyTemplate = (rowData: DataRow) => {
        return (
            <React.Fragment>
                <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">
                    {rowData.item?.queueFullName}
                </span>
            </React.Fragment>
        );
    };

    const branchBodyTemplate = (rowData: DataRow) => {
        return (
            <React.Fragment>
                <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">
                    {formatBranchDisplayLabel(rowData.item, branches)}
                </span>
            </React.Fragment>
        );
    };

    const callResetBodyTemplate = (rowData: any) => {
        const foundCallReset = callResetDictionary?.filter((item: any) => item?.dictionaryId === rowData?.item?.callReset);
        return (
            <React.Fragment>
                <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">
                    {foundCallReset?.[0]?.name}
                </span>
            </React.Fragment>
        );
    };

    const amdHangupBodyTemplate = (rowData: any) => {
        const foundAmdHangup = forcedClosingDictionary?.filter((item: any) => item?.dictionaryId === rowData?.item?.forcedClosing);
        return (
            <React.Fragment>
                <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">
                    {foundAmdHangup?.[0]?.name}
                </span>
            </React.Fragment>
        );
    };

    const renderStatusColumn = (rowData: any) => {
        let foundStatus = statusDictionary?.filter((status: any) => status?.dictionaryId === rowData?.item?.status);

        const statusMap: {
            [key: string]: string
        } = {
            101: 'p-badge status-active',
            103: 'p-badge status-success',
            104: 'p-badge status-unsuccessful',
            ACTION: 'p-badge status-action',
            102: 'p-badge status-processing'
        };

        const statusClass = statusMap[foundStatus?.[0]?.dictionaryId];

        return (
            <Badge value={foundStatus?.[0]?.name} className={`${statusClass} text-white customer-badge w-6 text-xs p-0`}
                   style={{maxWidth: '95px', minWidth: '95px'}}/>
        );
    };

    const amdHangupFilterTemplate = (options: any) => {
        return (
            <>
                <div className="mb-3 text-bold">Виберіть:</div>
                <MultiSelect
                    filter
                    value={options.value}
                    options={forcedClosingDictionary}
                    optionLabel='name'
                    optionValue={'dictionaryId'}
                    onChange={(e) => options.filterCallback(e.value, options.index)}
                    placeholder="нічого не обрано"
                    className="p-column-filter"
                />
            </>
        );
    };
    const callResetFilterTemplate = (options: any) => {
        return (
            <>
                <div className="mb-3 text-bold">Виберіть ініціатора</div>
                <MultiSelect
                    filter
                    value={options.value}
                    options={callResetDictionary || null}
                    optionValue="dictionaryId"
                    optionLabel="name"
                    onChange={(e) => options.filterCallback(e.value, options.index)}
                    placeholder="нічого не обрано"
                    className="p-column-filter"
                />
            </>
        );
    };

    const statusFilterTemplate = (options: any) => {
        return (
            <>
                <div className="mb-3 text-bold">Оберіть статус</div>
                <MultiSelect
                    filter
                    value={options.value}
                    options={statusDictionary || null}
                    optionValue="dictionaryId"
                    optionLabel="name"
                    onChange={(e) => options.filterCallback(e.value, options.index)}
                    placeholder="нічого не обрано"
                    className="p-column-filter"
                />
            </>
        );
    };

    const directionFilterTemplate = (options: any) => {
        return (
            <>
                <div className="mb-3 text-bold">Оберіть статус</div>
                <MultiSelect
                    filter
                    value={options.value}
                    optionValue="name"
                    options={queuesDirectoryDirectionType}
                    optionLabel="name"
                    onChange={(e) => options.filterCallback(e.value, options.index)}
                    placeholder="нічого не обрано"
                    className="p-column-filter"
                />
            </>
        );
    };
    const usersDataWithFullName = usersData?.map((userData: any) => {
        return {
            ...userData,
            fullName: `${userData?.lastName} ${userData?.firstName} ${userData?.middleName ? `${userData.middleName}` : ''}`
        }
    });

    const campaignListWithId = campaignList?.campaigns?.map((campaignData: any) => {
        return {
            ...campaignData,
            campaignWithId: `${campaignData.id} ${campaignData.name}`
        }
    });

    const queueListWithId = campaignList?.queues?.map((queueData: any) => {
        return {
            ...queueData,
            queueWithId: `${queueData?.id} ${queueData?.name}`
        }
    });

    const formattedBranches = branches?.map((branch: { id: any; name: any; }) => ({
        ...branch,
        label: `${branch.id} ${branch.name}`,
    }));

    const operatorItemTemplate = (item: any) => {
        return <div className="flex justify-content-between">
            <div>{item.fullName}</div>
            <div className="ml-3 text-sm">{!item?.isActive && 'Архівний'}</div>
        </div>;
    }

    const operatorFilterTemplate = (options: any) => {
        return (
            <>
                <div className="mb-3 text-bold">Оберіть:</div>
                <MultiSelect
                    value={options.value}
                    optionValue="userName"
                    selectedItemsLabel={options.value ? `Обрано: ${options.value.length}` : ""}
                    filter
                    options={usersDataWithFullName}
                    itemClassName="w-full operatorItem"
                    maxSelectedLabels={0}
                    itemTemplate={operatorItemTemplate}
                    optionLabel="fullName"
                    onChange={(e) => options.filterCallback(e.value, options.index)}
                    placeholder="нічого не обрано"
                    className="p-column-filter"

                />
            </>
        );
    };

    const ownerFilterTemplate = (options: any) => {
        let usersData: any
        if (!Array.isArray(usersDataWithFullName)) {
            console.error('usersDataWithFullName is not an array');
        } else {
            usersData = [
                {value: "", userName: ""},
                ...usersDataWithFullName
            ];
        }
        return (
            <>
                <div className="mb-3 text-bold">Оберіть:</div>
                <MultiSelect
                    value={options.value}
                    optionValue="userName"
                    selectedItemsLabel={options.value ? `Обрано: ${options.value.length}` : ""}
                    filter
                    options={usersData}
                    maxSelectedLabels={0}
                    optionLabel="userName"
                    onChange={(e) => options.filterCallback(e.value, options.index)}
                    placeholder="нічого не обрано"
                    className="p-column-filter"

                />
            </>
        );
    };

    const campaignFilterTemplate = (options: any) => {
        return (
            <>
                <div className="mb-3 text-bold">Оберіть:</div>
                <MultiSelect
                    value={options.value}
                    optionValue="id"
                    selectedItemsLabel={options.value ? `Обрано: ${options.value.length}` : ""}
                    filter
                    options={campaignListWithId}
                    maxSelectedLabels={0}
                    optionLabel="campaignWithId"
                    onChange={(e) => options.filterCallback(e.value, options.index)}
                    placeholder="нічого не обрано"
                    className="p-column-filter"

                />
            </>
        );
    };

    const branchFilterTemplate = (options: any) => {
        return (
            <>
                <div className="mb-3 text-bold">Оберіть:</div>
                <MultiSelect
                    filter
                    value={options.value}
                    options={formattedBranches}
                    optionLabel="label"
                    optionValue="id"
                    selectedItemsLabel={options?.value?.length ? `Обрано: ${options.value.length}` : "0"}
                    maxSelectedLabels={0}
                    onChange={(e: any) => options.filterCallback(e.value, options.index)}
                    placeholder="нічого не обрано"
                    className="p-column-filter"
                />
            </>
        );
    };

    const queueFilterTemplate = (options: any) => {
        return (
            <>
                <div className="mb-3 text-bold">Оберіть:</div>
                <MultiSelect
                    value={options.value}
                    optionValue="id"
                    selectedItemsLabel={options.value ? `Обрано: ${options.value.length}` : ""}
                    filter
                    options={queueListWithId}
                    maxSelectedLabels={0}
                    optionLabel="queueWithId"
                    onChange={(e) => options.filterCallback(e.value, options.index)}
                    placeholder="нічого не обрано"
                    className="p-column-filter"

                />
            </>
        );
    };

    const typeChannelItemTemplate = (option: any) => {
        let statusName = callTypeDictionary?.map((item: any) => {
            if (item.name === option) {
                return item.description
            }
        })
        return (
            <div className="p-multiselect-representative-option">
                <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">
                    {statusName}
                </span>
            </div>
        );
    }

    const selectedTypeChannelTemplate = (option: any) => {
        let statusName = callTypeDictionary?.map((item: any) => {
            if (item.name === option) {
                return item.description
            }
        })
        if (option) {
            return (
                <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">
                    {statusName},
                </span>
            );
        }

        return "Оберіть тип";
    }

    const dateFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <>
            <span className="title">Виберіть дату</span>
            <div className="flex field align-items-center max-w-15rem">
                <span className="title" style={{width: '35px'}}>З*</span>
                <Calendar className="mt-2" value={isStartDateFocused ? null : (filterDateTime || getDefaultStartDate())} onChange={(e: any) => {
                    options.filterCallback(e.value, options.index);
                    setFilterDateTime(e.value)
                }} onInput={(e: any) => {
                    const input = e.target as HTMLInputElement;

                    const digits = input.value.replace(/\D/g, "").slice(0, 8); // ddMMyyyy

                    const dd = digits.slice(0, 2);
                    const mm = digits.slice(2, 4);
                    const yyyy = digits.slice(4, 8);

                    const display =
                        (dd || "") +
                        (digits.length > 2 ? "/" + mm : "") +
                        (digits.length > 4 ? "/" + yyyy : "");

                    const newCaret =
                        digits.length +
                        (digits.length > 2 ? 1 : 0) +
                        (digits.length > 4 ? 1 : 0);

                    if (input.value !== display) {
                        input.value = display;
                        input.setSelectionRange(newCaret, newCaret);
                    }

                    if (digits.length === 8) {
                        const day = parseInt(dd, 10);
                        const month = parseInt(mm, 10) - 1; // 0-based
                        const year = parseInt(yyyy, 10);
                        const parsed = new Date(year, month, day);

                        const valid =
                            !isNaN(parsed.getTime()) &&
                            parsed.getDate() === day &&
                            parsed.getMonth() === month &&
                            parsed.getFullYear() === year;

                        setFilterDateTime(valid ? parsed : null);
                    }
                }} onFocus={(e: any) => {
                    setIsStartDateFocused(true);
                }} onBlur={(e: any) => {
                    setIsStartDateFocused(false);
                    const digits = e.target.value.replace(/\D/g, "");
                    if (digits.length !== 8) {
                        e.target.value = "";
                        setFilterDateTime(getDefaultStartDate());
                    } else if (!filterDateTime) {
                        setFilterDateTime(getDefaultStartDate());
                    }
                }} minDate={new Date(2023, 5, 1)} // 01.06.2023
                maxDate={new Date()}
                dateFormat="dd/mm/yy" placeholder="дд/мм/рр"/>
            </div>
            <div className="flex field align-items-center max-w-15rem">
                <span className="title" style={{width: '35px'}}>По*</span>
                <Calendar className="mt-2" value={isEndDateFocused ? null : (filterEndDateTime || getDefaultEndDate())} onChange={(e: any) => {
                    setFilterEndDateTime(e.value)
                }} onInput={(e: any) => {
                    const input = e.target as HTMLInputElement;

                    const digits = input.value.replace(/\D/g, "").slice(0, 8); // ddMMyyyy

                    const dd = digits.slice(0, 2);
                    const mm = digits.slice(2, 4);
                    const yyyy = digits.slice(4, 8);

                    const display =
                        (dd || "") +
                        (digits.length > 2 ? "/" + mm : "") +
                        (digits.length > 4 ? "/" + yyyy : "");

                    const newCaret =
                        digits.length +
                        (digits.length > 2 ? 1 : 0) +
                        (digits.length > 4 ? 1 : 0);

                    if (input.value !== display) {
                        input.value = display;
                        input.setSelectionRange(newCaret, newCaret);
                    }

                    if (digits.length === 8) {
                        const day = parseInt(dd, 10);
                        const month = parseInt(mm, 10) - 1; // 0-based
                        const year = parseInt(yyyy, 10);
                        const parsed = new Date(year, month, day);

                        const valid =
                            !isNaN(parsed.getTime()) &&
                            parsed.getDate() === day &&
                            parsed.getMonth() === month &&
                            parsed.getFullYear() === year;

                        setFilterEndDateTime(valid ? parsed : null);
                    }
                }} onFocus={(e: any) => {
                    setIsEndDateFocused(true);
                }} onBlur={(e: any) => {
                    setIsEndDateFocused(false);
                    const digits = e.target.value.replace(/\D/g, "");
                    if (digits.length !== 8) {
                        e.target.value = "";
                        setFilterEndDateTime(getDefaultEndDate());
                    } else if (!filterEndDateTime) {
                        setFilterEndDateTime(getDefaultEndDate());
                    }
                }} minDate={new Date(2023, 5, 1)} // 01.06.2023
                maxDate={new Date()}
                dateFormat="dd/mm/yy" placeholder="дд/мм/рр"/>
            </div>
            <div className="flex max-w-15rem">
                <div className="md:col-6">
                    <div className="time-item">
                        <span className="title">З*</span>
                        <Calendar
                            appendTo="self"
                            id="icon"
                            placeholder="00:00"
                            value={isStartFinishTimeFocused ? null : (startTime || getDefaultStartTime())}
                            timeOnly
                            hourFormat="24"
                            onChange={(e) => setStartTime(e.value)}
                            onFocus={() => {
                                setIsStartFinishTimeFocused(true);
                                if (startTime) {
                                    setStartTime(null);
                                }
                            }}
                            onInput={(e: any) => {
                                const input = e.target as HTMLInputElement;

                                let digits = input.value.replace(/\D/g, "").slice(0, 4);
                                const HH = digits.slice(0, 2);
                                const MM = digits.slice(2, 4);

                                const display = HH + (digits.length > 2 ? ":" + MM : "");

                                if (input.value !== display) {
                                    const caret = digits.length + (digits.length > 2 ? 1 : 0);
                                    input.value = display;
                                    input.setSelectionRange(caret, caret);
                                }

                                if (digits.length === 4) {
                                    const h = parseInt(HH, 10);
                                    const m = parseInt(MM, 10);
                                    const valid = h >= 0 && h <= 23 && m >= 0 && m <= 59;
                                    if (valid) {
                                        const base = startTime ? new Date(startTime) : new Date();
                                        base.setHours(h, m, 0, 0);
                                        setStartTime(base);
                                    }
                                }
                            }}
                            onBlur={() => {
                                setIsStartFinishTimeFocused(false);
                            }}
                        />
                    </div>
                </div>
                <div className="md:col-6">
                    <div className="time-item">
                        <span className="title">По*</span>
                        <Calendar
                            appendTo="self"
                            id="icon"
                            placeholder="00:00"
                            value={isEndFinishTimeFocused ? null : (endTime || getDefaultEndTime())}
                            timeOnly
                            hourFormat="24"
                            onChange={(e) => setEndTime(e.value)}
                            onFocus={() => {
                                setIsEndFinishTimeFocused(true);
                                if (endTime) {
                                    setEndTime(null);
                                }
                            }}
                            onInput={(e: any) => {
                                const input = e.target as HTMLInputElement;

                                let digits = input.value.replace(/\D/g, "").slice(0, 4);
                                const HH = digits.slice(0, 2);
                                const MM = digits.slice(2, 4);

                                const display = HH + (digits.length > 2 ? ":" + MM : "");

                                if (input.value !== display) {
                                    const caret = digits.length + (digits.length > 2 ? 1 : 0);
                                    input.value = display;
                                    input.setSelectionRange(caret, caret);
                                }

                                if (digits.length === 4) {
                                    const h = parseInt(HH, 10);
                                    const m = parseInt(MM, 10);
                                    const valid = h >= 0 && h <= 23 && m >= 0 && m <= 59;
                                    if (valid) {
                                        const base = endTime ? new Date(endTime) : new Date();
                                        base.setHours(h, m, 0, 0);
                                        setEndTime(base);
                                    }
                                }
                            }}
                            onBlur={() => {
                                setIsEndFinishTimeFocused(false);
                            }}
                        />
                    </div>
                </div>
            </div>
        </>
    };

    const dateEndFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <>
            <span className="title">Виберіть дату</span>
            <div className="flex field align-items-center max-w-15rem">
                <span className="title" style={{width: '35px'}}>З*</span>
                <Calendar className="mt-2" value={isFinishDateFocused ? null : (filterFinishDateTime || getDefaultStartDate())}
                          onChange={(e: any) => {
                              // options.filterCallback(e.value, options.index);
                              setFilterFinishDateTime(e.value)
                          }} onInput={(e: any) => {
                    const input = e.target as HTMLInputElement;

                    const digits = input.value.replace(/\D/g, "").slice(0, 8); // ddMMyyyy

                    const dd = digits.slice(0, 2);
                    const mm = digits.slice(2, 4);
                    const yyyy = digits.slice(4, 8);

                    const display =
                        (dd || "") +
                        (digits.length > 2 ? "/" + mm : "") +
                        (digits.length > 4 ? "/" + yyyy : "");

                    const newCaret =
                        digits.length +
                        (digits.length > 2 ? 1 : 0) +
                        (digits.length > 4 ? 1 : 0);

                    if (input.value !== display) {
                        input.value = display;
                        input.setSelectionRange(newCaret, newCaret);
                    }

                    if (digits.length === 8) {
                        const day = parseInt(dd, 10);
                        const month = parseInt(mm, 10) - 1; // 0-based
                        const year = parseInt(yyyy, 10);
                        const parsed = new Date(year, month, day);

                        const valid =
                            !isNaN(parsed.getTime()) &&
                            parsed.getDate() === day &&
                            parsed.getMonth() === month &&
                            parsed.getFullYear() === year;

                        setFilterFinishDateTime(valid ? parsed : null);
                    }
                }} onFocus={(e: any) => {
                    setIsFinishDateFocused(true);
                }} onBlur={(e: any) => {
                    setIsFinishDateFocused(false);
                    const digits = e.target.value.replace(/\D/g, "");
                    if (digits.length !== 8) {
                        e.target.value = "";
                        setFilterFinishDateTime(getDefaultStartDate());
                    } else if (!filterFinishDateTime) {
                        setFilterFinishDateTime(getDefaultStartDate());
                    }
                }} minDate={new Date(2023, 5, 1)} // 01.06.2023
                          maxDate={new Date()}
                          dateFormat="dd/mm/yy" placeholder="дд/мм/рр"/>
            </div>
            <div className="flex field align-items-center max-w-15rem">
                <span className="title" style={{width: '35px'}}>По*</span>
                <Calendar className="mt-2" value={isFinishEndDateFocused ? null : (filterFinishEndDateTime || getDefaultEndDate())}
                          onChange={(e: any) => {
                              setFilterFinishEndDateTime(e.value)
                          }} onInput={(e: any) => {
                    const input = e.target as HTMLInputElement;

                    const digits = input.value.replace(/\D/g, "").slice(0, 8); // ddMMyyyy

                    const dd = digits.slice(0, 2);
                    const mm = digits.slice(2, 4);
                    const yyyy = digits.slice(4, 8);

                    const display =
                        (dd || "") +
                        (digits.length > 2 ? "/" + mm : "") +
                        (digits.length > 4 ? "/" + yyyy : "");

                    const newCaret =
                        digits.length +
                        (digits.length > 2 ? 1 : 0) +
                        (digits.length > 4 ? 1 : 0);

                    if (input.value !== display) {
                        input.value = display;
                        input.setSelectionRange(newCaret, newCaret);
                    }

                    if (digits.length === 8) {
                        const day = parseInt(dd, 10);
                        const month = parseInt(mm, 10) - 1; // 0-based
                        const year = parseInt(yyyy, 10);
                        const parsed = new Date(year, month, day);

                        const valid =
                            !isNaN(parsed.getTime()) &&
                            parsed.getDate() === day &&
                            parsed.getMonth() === month &&
                            parsed.getFullYear() === year;

                        setFilterFinishEndDateTime(valid ? parsed : null);
                    }
                }} onFocus={(e: any) => {
                    setIsFinishEndDateFocused(true);
                }} onBlur={(e: any) => {
                    setIsFinishEndDateFocused(false);
                    const digits = e.target.value.replace(/\D/g, "");
                    if (digits.length !== 8) {
                        e.target.value = "";
                        setFilterFinishEndDateTime(getDefaultEndDate());
                    } else if (!filterFinishEndDateTime) {
                        setFilterFinishEndDateTime(getDefaultEndDate());
                    }
                }} minDate={new Date(2023, 5, 1)} // 01.06.2023
                          maxDate={new Date()}
                          dateFormat="dd/mm/yy" placeholder="дд/мм/рр"/>
            </div>
            <div className="flex max-w-15rem">
                <div className="md:col-6">
                    <div className="time-item">
                        <span className="title">З*</span>
                        <Calendar
                            appendTo="self"
                            id="icon"
                            placeholder="00:00"
                            value={isStartFinishTimeFocused ? null : (startFinishTime || getDefaultStartTime())}
                            timeOnly
                            hourFormat="24"
                            onChange={(e) => setStartFinishTime(e.value)}
                            onFocus={() => {
                                setIsStartFinishTimeFocused(true);
                            }}
                            onBlur={() => {
                                setIsStartFinishTimeFocused(false);
                                if (!startFinishTime) {
                                    const defaultTime = getDefaultStartTime();
                                    if (defaultTime) {
                                        setStartFinishTime(defaultTime);
                                    }
                                }
                            }}
                            onInput={(e: any) => {
                                const input = e.target as HTMLInputElement;

                                let digits = input.value.replace(/\D/g, "").slice(0, 4);
                                const HH = digits.slice(0, 2);
                                const MM = digits.slice(2, 4);

                                const display = HH + (digits.length > 2 ? ":" + MM : "");

                                if (input.value !== display) {
                                    const caret = digits.length + (digits.length > 2 ? 1 : 0);
                                    input.value = display;
                                    input.setSelectionRange(caret, caret);
                                }

                                if (digits.length === 4) {
                                    const h = parseInt(HH, 10);
                                    const m = parseInt(MM, 10);
                                    const valid = h >= 0 && h <= 23 && m >= 0 && m <= 59;
                                    if (valid) {
                                        const base = startFinishTime ? new Date(startFinishTime) : new Date();
                                        base.setHours(h, m, 0, 0);
                                        setStartFinishTime(base);
                                    }
                                }
                            }}
                        />
                    </div>
                </div>
                <div className="md:col-6">
                    <div className="time-item">
                        <span className="title">По*</span>
                        <Calendar
                            appendTo="self"
                            id="icon"
                            placeholder="00:00"
                            value={isEndFinishTimeFocused ? null : (endFinishTime || getDefaultEndTime())}
                            timeOnly
                            hourFormat="24"
                            onChange={(e) => setEndFinishTime(e.value)}
                            onFocus={() => {
                                setIsEndFinishTimeFocused(true);
                            }}
                            onBlur={() => {
                                setIsEndFinishTimeFocused(false);
                                if (!endFinishTime) {
                                    const defaultTime = getDefaultEndTime();
                                    if (defaultTime) {
                                        setEndFinishTime(defaultTime);
                                    }
                                }
                            }}
                            onInput={(e: any) => {
                                const input = e.target as HTMLInputElement;

                                let digits = input.value.replace(/\D/g, "").slice(0, 4);
                                const HH = digits.slice(0, 2);
                                const MM = digits.slice(2, 4);

                                const display = HH + (digits.length > 2 ? ":" + MM : "");

                                if (input.value !== display) {
                                    const caret = digits.length + (digits.length > 2 ? 1 : 0);
                                    input.value = display;
                                    input.setSelectionRange(caret, caret);
                                }

                                if (digits.length === 4) {
                                    const h = parseInt(HH, 10);
                                    const m = parseInt(MM, 10);
                                    const valid = h >= 0 && h <= 23 && m >= 0 && m <= 59;
                                    if (valid) {
                                        const base = endFinishTime ? new Date(endFinishTime) : new Date();
                                        base.setHours(h, m, 0, 0);
                                        setEndFinishTime(base);
                                    }
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
        </>
    };


    const fullCallDurationFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <>
            <span className="title">Виберіть час:</span>
            <div className="flex field align-items-center max-w-15rem">
                <span className="title" style={{width: '35px'}}>З*</span>
                <Calendar
                    appendTo="self"
                    id="icon"
                    placeholder="00:00:00"
                    timeOnly
                    showSeconds
                    hourFormat="24"
                    className={getActiveFilterClassName("mt-2", isTimeFilterActive('fullCallDuration'))}
                    value={fullCallDurationStartTime || null}
                    onChange={(e: any) => {
                        if (e.value) setfullCallDurationStartTime(e.value);
                    }}
                    onFocus={() => {
                        setfullCallDurationStartTime(null);
                    }}
                    onBlur={() => {
                        if (!fullCallDurationStartTime) {
                            const defaultTime = getDefaultStartTime();
                            if (defaultTime) {
                                setfullCallDurationStartTime(defaultTime);
                            }
                        }
                    }}
                    onInput={(e: any) => {
                        const input = e.target as HTMLInputElement;

                        const digits = input.value.replace(/\D/g, "").slice(0, 6);
                        const HH = digits.slice(0, 2);
                        const MM = digits.slice(2, 4);
                        const SS = digits.slice(4, 6);

                        const display =
                            HH +
                            (digits.length > 2 ? ":" + MM : "") +
                            (digits.length > 4 ? ":" + SS : "");

                        if (input.value !== display) {
                            const caret =
                                digits.length +
                                (digits.length > 2 ? 1 : 0) +
                                (digits.length > 4 ? 1 : 0);
                            input.value = display;
                            input.setSelectionRange(caret, caret);
                        }

                        if (digits.length === 6) {
                            const h = parseInt(HH, 10);
                            const m = parseInt(MM, 10);
                            const s = parseInt(SS, 10);
                            const valid =
                                h >= 0 && h <= 23 &&
                                m >= 0 && m <= 59 &&
                                s >= 0 && s <= 59;

                            if (valid) {
                                const base =
                                    fullCallDurationStartTime
                                        ? new Date(fullCallDurationStartTime)
                                        : (getDefaultStartTime() ? new Date(getDefaultStartTime()) : new Date());
                                base.setHours(h, m, s, 0);
                                setfullCallDurationStartTime(base);
                            }
                        }
                    }}
                    // showOnFocus={false}
                    // hideOnDateTimeSelect={false}
                />
            </div>
            <div className="flex field align-items-center max-w-15rem">
                <span className="title" style={{width: '35px'}}>По*</span>
                <Calendar
                    appendTo="self"
                    id="icon"
                    timeOnly
                    showSeconds
                    className={getActiveFilterClassName("mt-2", isTimeFilterActive('fullCallDuration'))}
                    value={fullCallDurationEndTime || null}
                    onChange={(e: any) => {
                        if (e.value) setfullCallDurationEndTime(e.value);
                    }}
                    onFocus={() => {
                        setfullCallDurationEndTime(null);
                    }}
                    onBlur={() => {
                        if (!fullCallDurationEndTime) {
                            const defaultTime = getDefaultStartTime();
                            if (defaultTime) {
                                setfullCallDurationEndTime(defaultTime);
                            }
                        }
                    }}
                    onInput={(e: any) => {
                        const input = e.target as HTMLInputElement;

                        const digits = input.value.replace(/\D/g, "").slice(0, 6);
                        const HH = digits.slice(0, 2);
                        const MM = digits.slice(2, 4);
                        const SS = digits.slice(4, 6);

                        const display =
                            HH +
                            (digits.length > 2 ? ":" + MM : "") +
                            (digits.length > 4 ? ":" + SS : "");

                        if (input.value !== display) {
                            const caret =
                                digits.length +
                                (digits.length > 2 ? 1 : 0) +
                                (digits.length > 4 ? 1 : 0);
                            input.value = display;
                            input.setSelectionRange(caret, caret);
                        }

                        if (digits.length === 6) {
                            const h = parseInt(HH, 10);
                            const m = parseInt(MM, 10);
                            const s = parseInt(SS, 10);
                            const valid =
                                h >= 0 && h <= 23 &&
                                m >= 0 && m <= 59 &&
                                s >= 0 && s <= 59;

                            if (valid) {
                                const base =
                                    fullCallDurationEndTime
                                        ? new Date(fullCallDurationEndTime)
                                        : (getDefaultStartTime() ? new Date(getDefaultStartTime()) : new Date());
                                base.setHours(h, m, s, 0);
                                setfullCallDurationEndTime(base);
                            }
                        }
                    }}
                    placeholder="00:00:00"
                    hourFormat="24"
                    // showOnFocus={false}
                    // hideOnDateTimeSelect={false}
                />
            </div>
        </>
    };

    const durationFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <>
            <span className="title">Виберіть час:</span>
            <div className="flex field align-items-center max-w-15rem">
                <span className="title" style={{width: '35px'}}>З*</span>
                <Calendar
                    appendTo="self"
                    id="icon"
                    timeOnly
                    showSeconds
                    className={getActiveFilterClassName("mt-2", isTimeFilterActive('duration'))}
                    value={durationStartTime || null}
                    onChange={(e: any) => {
                        if (e.value) setDurationStartTime(e.value);
                    }}
                    onFocus={() => {
                        setDurationStartTime(null);
                    }}
                    onBlur={() => {
                        if (!durationStartTime) {
                            const defaultTime = getDefaultStartTime();
                            if (defaultTime) {
                                setDurationStartTime(defaultTime);
                            }
                        }
                    }}
                    onInput={(e: any) => {
                        const input = e.target as HTMLInputElement;

                        const digits = input.value.replace(/\D/g, "").slice(0, 6);
                        const HH = digits.slice(0, 2);
                        const MM = digits.slice(2, 4);
                        const SS = digits.slice(4, 6);

                        const display =
                            HH +
                            (digits.length > 2 ? ":" + MM : "") +
                            (digits.length > 4 ? ":" + SS : "");

                        if (input.value !== display) {
                            const caret =
                                digits.length +
                                (digits.length > 2 ? 1 : 0) +
                                (digits.length > 4 ? 1 : 0);
                            input.value = display;
                            input.setSelectionRange(caret, caret);
                        }

                        if (digits.length === 6) {
                            const h = parseInt(HH, 10);
                            const m = parseInt(MM, 10);
                            const s = parseInt(SS, 10);
                            const valid =
                                h >= 0 && h <= 23 &&
                                m >= 0 && m <= 59 &&
                                s >= 0 && s <= 59;

                            if (valid) {
                                const base =
                                    durationStartTime
                                        ? new Date(durationStartTime)
                                        : (getDefaultStartTime() ? new Date(getDefaultStartTime()) : new Date());
                                base.setHours(h, m, s, 0);
                                setDurationStartTime(base);
                            }
                        }
                    }}
                    placeholder="00:00:00"
                    hourFormat="24"
                    // showOnFocus={false}
                    // hideOnDateTimeSelect={false}
                />
            </div>
            <div className="flex field align-items-center max-w-15rem">
                <span className="title" style={{width: '35px'}}>По*</span>
                <Calendar
                    appendTo="self"
                    id="icon"
                    timeOnly
                    showSeconds
                    className={getActiveFilterClassName("mt-2", isTimeFilterActive('duration'))}
                    value={durationEndTime || null}
                    onChange={(e: any) => {
                        if (e.value) setDurationEndTime(e.value);
                    }}
                    onFocus={() => {
                        setDurationEndTime(null);
                    }}
                    onBlur={() => {
                        if (!durationEndTime) {
                            const defaultTime = getDefaultStartTime();
                            if (defaultTime) {
                                setDurationEndTime(defaultTime);
                            }
                        }
                    }}
                    onInput={(e: any) => {
                        const input = e.target as HTMLInputElement;

                        const digits = input.value.replace(/\D/g, "").slice(0, 6);
                        const HH = digits.slice(0, 2);
                        const MM = digits.slice(2, 4);
                        const SS = digits.slice(4, 6);

                        const display =
                            HH +
                            (digits.length > 2 ? ":" + MM : "") +
                            (digits.length > 4 ? ":" + SS : "");

                        if (input.value !== display) {
                            const caret =
                                digits.length +
                                (digits.length > 2 ? 1 : 0) +
                                (digits.length > 4 ? 1 : 0);
                            input.value = display;
                            input.setSelectionRange(caret, caret);
                        }

                        if (digits.length === 6) {
                            const h = parseInt(HH, 10);
                            const m = parseInt(MM, 10);
                            const s = parseInt(SS, 10);
                            const valid =
                                h >= 0 && h <= 23 &&
                                m >= 0 && m <= 59 &&
                                s >= 0 && s <= 59;

                            if (valid) {
                                const base =
                                    durationEndTime
                                        ? new Date(durationEndTime)
                                        : (getDefaultStartTime() ? new Date(getDefaultStartTime()) : new Date());
                                base.setHours(h, m, s, 0);
                                setDurationEndTime(base);
                            }
                        }
                    }}
                    placeholder="00:00:00"
                    hourFormat="24"
                    // showOnFocus={false}
                    // hideOnDateTimeSelect={false}
                />
            </div>
        </>
    };

    const reactionClientFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <>
            <span className="title">Виберіть час:</span>
            <div className="flex field align-items-center max-w-15rem">
                <span className="title" style={{width: '35px'}}>З*</span>
                <Calendar
                    appendTo="self"
                    id="icon"
                    timeOnly
                    showSeconds
                    className={getActiveFilterClassName("mt-2", isTimeFilterActive('reactionClient'))}
                    value={reactionClientStartTime || null}
                    onChange={(e: any) => {
                        if (e.value) setReactionClientStartTime(e.value);
                    }}
                    onFocus={() => {
                        setReactionClientStartTime(null);
                    }}
                    onBlur={() => {
                        if (!reactionClientStartTime) {
                            const defaultTime = getDefaultStartTime();
                            if (defaultTime) {
                                setReactionClientStartTime(defaultTime);
                            }
                        }
                    }}
                    onInput={(e: any) => {
                        const input = e.target as HTMLInputElement;

                        const digits = input.value.replace(/\D/g, "").slice(0, 6);
                        const HH = digits.slice(0, 2);
                        const MM = digits.slice(2, 4);
                        const SS = digits.slice(4, 6);

                        const display =
                            HH +
                            (digits.length > 2 ? ":" + MM : "") +
                            (digits.length > 4 ? ":" + SS : "");

                        if (input.value !== display) {
                            const caret =
                                digits.length +
                                (digits.length > 2 ? 1 : 0) +
                                (digits.length > 4 ? 1 : 0);
                            input.value = display;
                            input.setSelectionRange(caret, caret);
                        }

                        if (digits.length === 6) {
                            const h = parseInt(HH, 10);
                            const m = parseInt(MM, 10);
                            const s = parseInt(SS, 10);
                            const valid =
                                h >= 0 && h <= 23 &&
                                m >= 0 && m <= 59 &&
                                s >= 0 && s <= 59;

                            if (valid) {
                                const base =
                                    reactionClientStartTime
                                        ? new Date(reactionClientStartTime)
                                        : (getDefaultStartTime() ? new Date(getDefaultStartTime()) : new Date());
                                base.setHours(h, m, s, 0);
                                setReactionClientStartTime(base);
                            }
                        }
                    }}
                    placeholder="00:00:00"
                    hourFormat="24"
                    // showOnFocus={false}
                    // hideOnDateTimeSelect={false}
                />
            </div>
            <div className="flex field align-items-center max-w-15rem">
                <span className="title" style={{width: '35px'}}>По*</span>
                <Calendar
                    appendTo="self"
                    id="icon"
                    timeOnly
                    showSeconds
                    className={getActiveFilterClassName("mt-2", isTimeFilterActive('reactionClient'))}
                    value={reactionClientEndTime || null}
                    onChange={(e: any) => {
                        if (e.value) setReactionClientEndTime(e.value);
                    }}
                    onFocus={() => {
                        setReactionClientEndTime(null);
                    }}
                    onBlur={() => {
                        if (!reactionClientEndTime) {
                            const defaultTime = getDefaultStartTime();
                            if (defaultTime) {
                                setReactionClientEndTime(defaultTime);
                            }
                        }
                    }}
                    onInput={(e: any) => {
                        const input = e.target as HTMLInputElement;

                        const digits = input.value.replace(/\D/g, "").slice(0, 6);
                        const HH = digits.slice(0, 2);
                        const MM = digits.slice(2, 4);
                        const SS = digits.slice(4, 6);

                        const display =
                            HH +
                            (digits.length > 2 ? ":" + MM : "") +
                            (digits.length > 4 ? ":" + SS : "");

                        if (input.value !== display) {
                            const caret =
                                digits.length +
                                (digits.length > 2 ? 1 : 0) +
                                (digits.length > 4 ? 1 : 0);
                            input.value = display;
                            input.setSelectionRange(caret, caret);
                        }

                        if (digits.length === 6) {
                            const h = parseInt(HH, 10);
                            const m = parseInt(MM, 10);
                            const s = parseInt(SS, 10);
                            const valid =
                                h >= 0 && h <= 23 &&
                                m >= 0 && m <= 59 &&
                                s >= 0 && s <= 59;

                            if (valid) {
                                const base =
                                    reactionClientEndTime
                                        ? new Date(reactionClientEndTime)
                                        : (getDefaultStartTime() ? new Date(getDefaultStartTime()) : new Date());
                                base.setHours(h, m, s, 0);
                                setReactionClientEndTime(base);
                            }
                        }
                    }}
                    placeholder="00:00:00"
                    hourFormat="24"
                    // showOnFocus={false}
                    // hideOnDateTimeSelect={false}
                />
            </div>
        </>
    };

    const reactionOperatorFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <>
            <span className="title">Виберіть час:</span>
            <div className="flex field align-items-center max-w-15rem">
                <span className="title" style={{width: '35px'}}>З*</span>
                <Calendar
                    appendTo="self"
                    id="icon"
                    timeOnly
                    showSeconds
                    className={getActiveFilterClassName("mt-2", isTimeFilterActive('reactionOperator'))}
                    value={reactionOperatorStartTime || null}
                    onChange={(e: any) => {
                        if (e.value) setReactionOperatorStartTime(e.value);
                    }}
                    onFocus={() => {
                        setReactionOperatorStartTime(null);
                    }}
                    onBlur={() => {
                        if (!reactionOperatorStartTime) {
                            const defaultTime = getDefaultStartTime();
                            if (defaultTime) {
                                setReactionOperatorStartTime(defaultTime);
                            }
                        }
                    }}
                    onInput={(e: any) => {
                        const input = e.target as HTMLInputElement;

                        const digits = input.value.replace(/\D/g, "").slice(0, 6);
                        const HH = digits.slice(0, 2);
                        const MM = digits.slice(2, 4);
                        const SS = digits.slice(4, 6);

                        const display =
                            HH +
                            (digits.length > 2 ? ":" + MM : "") +
                            (digits.length > 4 ? ":" + SS : "");

                        if (input.value !== display) {
                            const caret =
                                digits.length +
                                (digits.length > 2 ? 1 : 0) +
                                (digits.length > 4 ? 1 : 0);
                            input.value = display;
                            input.setSelectionRange(caret, caret);
                        }

                        if (digits.length === 6) {
                            const h = parseInt(HH, 10);
                            const m = parseInt(MM, 10);
                            const s = parseInt(SS, 10);
                            const valid =
                                h >= 0 && h <= 23 &&
                                m >= 0 && m <= 59 &&
                                s >= 0 && s <= 59;

                            if (valid) {
                                const base =
                                    reactionOperatorStartTime
                                        ? new Date(reactionOperatorStartTime)
                                        : (getDefaultStartTime() ? new Date(getDefaultStartTime()) : new Date());
                                base.setHours(h, m, s, 0);
                                setReactionOperatorStartTime(base);
                            }
                        }
                    }}
                    placeholder="00:00:00"
                    hourFormat="24"
                    // showOnFocus={false}
                    // hideOnDateTimeSelect={false}
                />
            </div>
            <div className="flex field align-items-center max-w-15rem">
                <span className="title" style={{width: '35px'}}>По*</span>
                <Calendar
                    appendTo="self"
                    id="icon"
                    timeOnly
                    showSeconds
                    className={getActiveFilterClassName("mt-2", isTimeFilterActive('reactionOperator'))}
                    value={reactionOperatorEndTime || null}
                    onChange={(e: any) => {
                        if (e.value) setReactionOperatorEndTime(e.value);
                    }}
                    onFocus={() => {
                        setReactionOperatorEndTime(null);
                    }}
                    onBlur={() => {
                        if (!reactionOperatorEndTime) {
                            const defaultTime = getDefaultStartTime();
                            if (defaultTime) {
                                setReactionOperatorEndTime(defaultTime);
                            }
                        }
                    }}
                    onInput={(e: any) => {
                        const input = e.target as HTMLInputElement;

                        const digits = input.value.replace(/\D/g, "").slice(0, 6);
                        const HH = digits.slice(0, 2);
                        const MM = digits.slice(2, 4);
                        const SS = digits.slice(4, 6);

                        const display =
                            HH +
                            (digits.length > 2 ? ":" + MM : "") +
                            (digits.length > 4 ? ":" + SS : "");

                        if (input.value !== display) {
                            const caret =
                                digits.length +
                                (digits.length > 2 ? 1 : 0) +
                                (digits.length > 4 ? 1 : 0);
                            input.value = display;
                            input.setSelectionRange(caret, caret);
                        }

                        if (digits.length === 6) {
                            const h = parseInt(HH, 10);
                            const m = parseInt(MM, 10);
                            const s = parseInt(SS, 10);
                            const valid =
                                h >= 0 && h <= 23 &&
                                m >= 0 && m <= 59 &&
                                s >= 0 && s <= 59;

                            if (valid) {
                                const base =
                                    reactionOperatorEndTime
                                        ? new Date(reactionOperatorEndTime)
                                        : (getDefaultStartTime() ? new Date(getDefaultStartTime()) : new Date());
                                base.setHours(h, m, s, 0);
                                setReactionOperatorEndTime(base);
                            }
                        }
                    }}
                    placeholder="00:00:00"
                    hourFormat="24"
                    // showOnFocus={false}
                    // hideOnDateTimeSelect={false}
                />
            </div>
        </>
    };

    const typeChannelFilterTemplate = (options: any) => {
        return (
            <>
                <div className="mb-3 text-bold">Оберіть тип</div>
                <MultiSelect
                    filter
                    value={options.value}
                    options={callTypeDictionary?.map((item: { name: any; }) => item.name)}
                    itemTemplate={typeChannelItemTemplate}
                    selectedItemTemplate={selectedTypeChannelTemplate}
                    onChange={(e) => options.filterCallback(e.value, options.index)}
                    placeholder="нічого не обрано"
                    className="p-column-filter mb-3"
                />
            </>
        );
    };
    const ownerTypeFilterTemplate = (options: any) => {
        return (
            <>
                <div className="mb-3 text-bold">Оберіть тип</div>
                <MultiSelect
                    filter
                    value={options.value}
                    options={ownerTypeDictionary}
                    optionLabel="description"
                    optionValue="dictionaryId"
                    onChange={(e) => options.filterCallback(e.value, options.index)}
                    placeholder="нічого не обрано"
                    className="p-column-filter mb-3"
                />
            </>
        );
    };

    const BSessionIcon = () => {
        return <i className="pi pi-reply mr-2" style={{fontSize: '1rem', transform: 'rotate(270deg)'}}></i>
    }

    // const convertMillisecondsToTime = (totalMilliseconds: number): string => {
    //     const hours = Math.floor(totalMilliseconds / (1000 * 60 * 60));
    //     const minutes = Math.floor((totalMilliseconds % (1000 * 60 * 60)) / (1000 * 60));
    //     const seconds = Math.floor((totalMilliseconds % (1000 * 60)) / 1000);
    //
    //     return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    // };

    const convertSecondsToTime = (totalSeconds: number): string => {
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = Math.floor(totalSeconds % 60);

        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };

    const contactNameBodyTemplate = (rowData: any) => {
        return (
            <React.Fragment>
                <span style={{verticalAlign: 'middle'}} className="image-text">
                    {rowData.item?.pathSegment ?
                        <a target="_blank" className="mb-2" href={`${rowData.item?.pathSegment}?sessionId=${rowData.item?.sessionId}`}>{rowData.item?.contactName}</a> :
                        <p className="m-0 mb-2">{rowData.item?.contactName}</p>}
                    {/*{rowData.item?.contactName || '- - -'}*/}
                </span>
            </React.Fragment>
        );
    };

    const aniFilterTemplate = (options: any) => {
        return<InputText placeholder="Введіть назву клiента" className="mt-2" value={options.value || ''}
                         onChange={(e: any) => {
                             const cleaned = e.target.value?.replace(/[()\-\s\n\t\r+,;!'"?:$%&/]/g, '');
                             options.filterCallback(cleaned, options.index);
                         }}/>
    };

    const firstLevelTableCase = (name: string, i: number) => {
        let itemName: any;

        switch (name) {
            case "ani":
                itemName = <Column
                    key={i}
                    field="item.ani"
                    filterField="ani"
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterPlaceholder="Введіть назву клiента"
                    filter
                    filterElement={aniFilterTemplate}
                    body={aniBodyTemplate}
                    filterClear={filterClearTemplate}
                    filterApply={filterApplyTemplate}
                    filterMenuClassName={'filterStart'}
                    bodyClassName={(rowData) => rowData.item?.isMatchingSessionId ? 'your-custom-class' : ''}
                    header={'Клiент'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '165px'}}
                />;
                break;
            case "aNumber":
                itemName = <Column
                    key={i}
                    field="item.aNumber"
                    filterField="aNumber"
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterPlaceholder="Введіть транк"
                    filter
                    body={aNumberBodyTemplate}
                    filterClear={filterClearTemplate}
                    filterApply={filterApplyTemplate}
                    filterMenuClassName={'filterStart'}
                    bodyClassName={(rowData) => rowData.item?.isMatchingSessionId ? 'your-custom-class' : ''}
                    header={'Транк'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '150px'}}
                />;
                break;
            case "ownerUserName":
                itemName = <Column
                    key={i}
                    field="item.ownerUserName"
                    filterField="ownerUserName"
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterPlaceholder="Введіть назву власника"
                    filter={hasUsersAccess}
                    filterElement={hasUsersAccess ? ownerFilterTemplate : undefined}
                    filterClear={hasUsersAccess ? filterClearTemplate : undefined}
                    filterApply={hasUsersAccess ? filterApplyTemplate : undefined}
                    header={'Власник дзвінка'}
                    body={typeBodyTemplate}
                    filterMenuClassName={'filterStart'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '200px'}}
                />;
                break;
            case "fullName":
                itemName = <Column
                    field="item.fullName"
                    key={i}
                    sortable
                    filterField="fullName"
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterPlaceholder="Введіть назву оператора"
                    filter={hasUsersAccess}
                    filterElement={hasUsersAccess ? operatorFilterTemplate : undefined}
                    filterClear={hasUsersAccess ? filterClearTemplate : undefined}
                    filterApply={hasUsersAccess ? filterApplyTemplate : undefined}
                    header={renderHeader('Оператор', 'Username')}
                    body={typeOperatorTemplate}
                    filterMenuClassName={'filterStart'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '200px'}}
                />;
                break;
            case "direction":
                itemName = <Column
                    field="item.direction"
                    key={i}
                    filterField="direction"
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterPlaceholder="Введіть назву оператора"
                    filter
                    filterElement={directionFilterTemplate}
                    filterClear={filterClearTemplate}
                    filterApply={filterApplyTemplate}
                    header={'Тип Активності'}
                    body={typeDirectionBodyTemplate}
                    filterMenuClassName={'filterStart'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '165px'}}
                />;
                break;
            case "contactName":
                itemName = <Column
                    key={i}
                    // header={renderHeader('Реакція Оператора', 'ContactName')}
                    header="Контакт"
                    className="justify-content-start"
                    body={contactNameBodyTemplate}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '200px'}}
                    // sortable
                    // filterPlaceholder="Введіть час"
                    // filter
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterClear={filterClearTemplate}
                    filterApply={filterApplyTemplate}
                    filterField="reactionOperator"
                    filterElement={reactionOperatorFilterTemplate}
                />;
                break;
            case "campaignFullName":
                itemName = <Column
                    field="item.campaignId"
                    sortable
                    key={i}
                    filterField="campaignFullName"
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterPlaceholder="Введіть назву кампанії"
                    filter
                    body={campaignBodyTemplate}
                    filterElement={campaignFilterTemplate}
                    filterClear={filterClearTemplate}
                    filterApply={filterApplyTemplate}
                    filterMenuClassName={'filterStart'}
                    header={renderHeader('ID / Назва Кампанii', 'CampaignId')}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '200px'}}
                />;
                break;
            case "branchId":
                itemName = <Column
                    field="item.branchId"
                    sortable
                    key={i}
                    filterField="branchId"
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterPlaceholder="Введіть branch"
                    filter={hasBranchAccess}
                    body={branchBodyTemplate}
                    filterElement={hasBranchAccess ? branchFilterTemplate : undefined}
                    filterClear={hasBranchAccess ? filterClearTemplate : undefined}
                    filterApply={hasBranchAccess ? filterApplyTemplate : undefined}
                    filterMenuClassName={'filterStart'}
                    header={renderHeader('ID / Branch', 'BranchId')}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '200px'}}
                />;
                break;
            case "queueFullName":
                itemName = <Column
                    field="item.queueId"
                    sortable
                    key={i}
                    filterField="queueFullName"
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterPlaceholder="Введіть назву черги"
                    filter
                    body={queueBodyTemplate}
                    filterElement={queueFilterTemplate}
                    filterClear={filterClearTemplate}
                    filterApply={filterApplyTemplate}
                    filterMenuClassName={'filterStart'}
                    header={renderHeader('ID / Назва Черги', 'QueueId')}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '200px'}}
                />;
                break;
            case "status":
                itemName = <Column
                    field="item.status"
                    header={renderHeader('Статус', 'Status')}
                    sortable
                    key={i}
                    filterField="status"
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterElement={statusFilterTemplate}
                    filter
                    filterClear={filterClearTemplate}
                    filterApply={filterApplyTemplate}
                    filterMenuClassName={'filterStart'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '150px'}}
                    body={renderStatusColumn}
                />;
                break;
            case "callType":
                itemName = <Column
                    field="item.callType"
                    header={'Активність'}
                    key={i}
                    filterField="callType"
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterPlaceholder="Введіть ID кампанії"
                    filter
                    filterElement={typeChannelFilterTemplate}
                    filterClear={filterClearTemplate}
                    filterApply={filterApplyTemplate}
                    body={renderActivityColumn}
                    filterMenuClassName={'filterStart'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '150px'}}
                />;
                break;
            case "callResetName":
                itemName = <Column
                    field="item.callReset"
                    sortable
                    filterField="callResetName"
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filter
                    key={i}
                    filterElement={callResetFilterTemplate}
                    filterClear={filterClearTemplate}
                    filterApply={filterApplyTemplate}
                    header={renderHeader('Завершив', 'CallReset')}
                    body={callResetBodyTemplate}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '160px'}}
                    filterMenuClassName={'filterStart'}
                />;
                break;
            case "forcedClosing":
                itemName = <Column
                    field="forcedClosing"
                    header={renderHeader('Причина завершення', 'ForcedClosing')}
                    sortable
                    key={i}
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterClear={filterClearTemplate}
                    filterApply={filterApplyTemplate}
                    filterElement={amdHangupFilterTemplate}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '180px'}}
                    body={amdHangupBodyTemplate}
                    filterMenuClassName={'filterStart'}
                    filter
                    filterField="forcedClosing"
                />;
                break;
            case "start":
                itemName = <Column
                    field="item.start"
                    filterField="start"
                    key={i}
                    filterElement={dateFilterTemplate}
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterPlaceholder="Введіть ID кампанії"
                    filter

                    filterClear={filterClearTemplate}
                    filterApply={filterApplyTemplate}
                    filterMenuClassName={'filterStart'}
                    header={renderHeader('Початок', 'Start')}
                    sortable
                    style={{cursor: 'pointer', width: `100%`, minWidth: '170px'}}
                />;
                break;
            case "fullCallDuration":
                itemName = <Column
                    key={i}
                    header={renderHeader('Тривалість дзвінка', 'FullCallDuration')}
                    className="justify-content-start"
                    body={(data) => data.item.fullCallDuration && data?.item?.fullCallDuration !== -1 ? convertSecondsToTime(data?.item.fullCallDuration) : data?.item?.fullCallDuration === 0 ? '00:00:00' : '- - -'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '165px'}}
                    sortable
                    filterPlaceholder="Введіть час"
                    filter
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterClear={filterClearTemplate}
                    filterApply={filterApplyTemplate}
                    filterField="fullCallDuration"
                    filterElement={fullCallDurationFilterTemplate}
                />;
                break;
            case "duration":
                itemName = <Column
                    key={i}
                    header={renderHeader('Тривалість розмови', 'Duration')}
                    className="justify-content-start"
                    body={(data) => data?.item?.duration && data?.item?.duration !== -1 ? convertSecondsToTime(data?.item?.duration) : data?.item?.duration === 0 ? '00:00:00' : '- - -'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '165px'}}
                    sortable
                    filterPlaceholder="Введіть час"
                    filter
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterClear={filterClearTemplate}
                    filterApply={filterApplyTemplate}
                    filterField="duration"
                    filterElement={durationFilterTemplate}
                />;
                break;
            case "reactionClient":
                itemName = <Column
                    key={i}
                    header={renderHeader('Реакція Клієнта', 'ReactionClient')}
                    className="justify-content-start"
                    body={(data) => data?.item?.reactionClient && data?.item?.reactionClient !== -1 ? convertSecondsToTime(data?.item?.reactionClient) : data?.item?.reactionClient === 0 ? '00:00:00' : '- - -'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '165px'}}
                    sortable
                    filterPlaceholder="Введіть час"
                    filter
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterClear={filterClearTemplate}
                    filterApply={filterApplyTemplate}
                    filterField="reactionClient"
                    filterElement={reactionClientFilterTemplate}
                />;
                break;
            case "reactionOperator":
                itemName = <Column
                    key={i}
                    header={renderHeader('Реакція Оператора', 'ReactionOperator')}
                    className="justify-content-start"
                    body={(data) => data?.item?.reactionOperator && data?.item?.reactionOperator !== -1 ? convertSecondsToTime(data?.item?.reactionOperator) : data?.item?.reactionOperator === 0 ? '00:00:00' : '- - -'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '165px'}}
                    sortable
                    filterPlaceholder="Введіть час"
                    filter
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterClear={filterClearTemplate}
                    filterApply={filterApplyTemplate}
                    filterField="reactionOperator"
                    filterElement={reactionOperatorFilterTemplate}
                />;
                break;
            case "ownerType":
                let foundOwnerType = (ownerTypeId: any) => {
                    let ownerType = ownerTypeDictionary?.filter((status: any) => status?.dictionaryId === ownerTypeId);
                    return ownerType?.[0]?.description;
                }

                itemName = <Column
                    key={i}
                    header={renderHeader('Тип власника', 'OwnerType')}
                    className="justify-content-start"
                    body={(data) => foundOwnerType(data?.item?.ownerType) || ''}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '170px'}}
                    sortable
                    filterPlaceholder="Виберіть власника"
                    filter
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterClear={filterClearTemplate}
                    filterApply={filterApplyTemplate}
                    filterField="ownerType"
                    filterElement={ownerTypeFilterTemplate}
                />;
                break;
            case "end":
                itemName = <Column
                    key={i}
                    header={renderHeader('Завершення', 'End')}
                    className="justify-content-start"
                    body={(data) => data?.item?.end ? formatDateTime(data?.item?.end) : '- - -'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '170px'}}
                    sortable
                    filterPlaceholder="Введіть час"
                    filter
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterClear={filterClearTemplate}
                    filterApply={filterApplyTemplate}
                    filterField="end"
                    filterElement={dateEndFilterTemplate}
                />;
                break;
            default:
                itemName = itemName = <Column
                    key={i}
                    className="justify-content-start"
                    header={renderHeader('', '')}
                    body={''}
                />;
        }

        return itemName;
    }

    const secondLevelTableCase = (name: string, i: number) => {
        let itemName: any;
        switch (name) {
            case "ani":
                itemName = <Column
                    key={i}
                    className="justify-content-start"
                    field="item.ani"
                    body={aniBodyTemplate}
                    headerClassName='hidden'
                    style={{cursor: 'pointer', width: `100%`, minWidth: '165px'}}
                />;
                break;
            case "aNumber":
                itemName = <Column
                    key={i}
                    className="justify-content-start"
                    field="item.aNumber"
                    body={aNumberBodyTemplate}
                    headerClassName='hidden'
                    style={{cursor: 'pointer', width: `100%`, minWidth: '150px'}}
                />;
                break;
            case "ownerUserName":
                itemName = <Column
                    key={i}
                    field="ownerUserName"
                    className="justify-content-start"
                    headerClassName='hidden'
                    body={typeBodyTemplate}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '200px'}}
                />;
                break;
            case "contactName":
                itemName = <Column
                    key={i}
                    className="justify-content-start"
                    field="item.contactName"
                    body={contactNameBodyTemplate}
                    headerClassName='hidden'
                    style={{cursor: 'pointer', width: `100%`, minWidth: '200px'}}
                />;
                break;
            case "fullName":
                itemName = <Column
                    key={i}
                    field="fullName"
                    className="justify-content-start"
                    headerClassName='hidden'
                    body={typeOperatorTemplate}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '200px'}}
                />;
                break;
            case "direction":
                itemName = <Column
                    key={i}
                    className="justify-content-start"
                    field="direction"
                    headerClassName='hidden'
                    body={typeDirectionBodyTemplate}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '165px'}}
                />;
                break;
            case "campaignFullName":
                itemName = <Column
                    key={i}
                    className="justify-content-start"
                    field="campaignId"
                    headerClassName='hidden'
                    body={campaignBodyTemplate}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '200px'}}
                />;
                break;
            case "branchId":
                itemName = <Column
                    key={i}
                    className="justify-content-start"
                    field="branchId"
                    headerClassName='hidden'
                    body={branchBodyTemplate}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '200px'}}
                />;
                break;
            case "queueFullName":
                itemName = <Column
                    key={i}
                    field="queueId"
                    className="justify-content-start queue-column"
                    body={queueBodyTemplate}
                    headerClassName='hidden'
                    style={{cursor: 'pointer', width: `100%`, minWidth: '200px'}}
                />;
                break;
            case "status":
                itemName = <Column
                    key={i}
                    className="justify-content-start status-column"
                    field="status"
                    headerClassName='hidden'
                    style={{cursor: 'pointer', width: `100%`, minWidth: '150px'}}
                    body={renderStatusColumn}
                />;
                break;
            case "callType":
                itemName = <Column
                    key={i}
                    field="callType"
                    className="justify-content-start channel-column"
                    body={renderActivityColumn}
                    headerClassName='hidden'
                    style={{cursor: 'pointer', width: `100%`, minWidth: '150px'}}
                />;
                break;
            case "callResetName":
                itemName = <Column
                    key={i}
                    field="callResetName"
                    className="justify-content-start"
                    headerClassName='hidden'
                    body={callResetBodyTemplate}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '160px'}}
                />;
                break;
            case "forcedClosing":
                itemName = <Column
                    key={i}
                    field="forcedClosing"
                    className="justify-content-start"
                    headerClassName='hidden'
                    style={{cursor: 'pointer', width: `100%`, minWidth: '180px'}}
                    body={amdHangupBodyTemplate}
                />;
                break;
            case "start":
                itemName = <Column
                    key={i}
                    field="item.start"
                    className="justify-content-start"
                    sortable
                    headerClassName='hidden'
                    style={{cursor: 'pointer', width: `100%`, minWidth: '170px'}}
                />;
                break;
            case "fullCallDuration":
                itemName = <Column
                    key={i}
                    header={'Тривалість дзвінка'}
                    headerClassName='hidden'
                    className="justify-content-start"
                    body={(data) => data.item.fullCallDuration && data?.item?.fullCallDuration !== -1 ? convertSecondsToTime(data?.item.fullCallDuration) : data?.item?.fullCallDuration === 0 ? '00:00:00' : '- - -'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '165px'}}
                />;
                break;
            case "duration":
                itemName = <Column
                    key={i}
                    header={'Тривалість розмови'}
                    headerClassName='hidden'
                    className="justify-content-start"
                    body={(data) => data?.item?.duration && data?.item?.duration !== -1 ? convertSecondsToTime(data?.item?.duration) : data?.item?.duration === 0 ? '00:00:00' : '- - -'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '165px'}}
                />;
                break;
            case "reactionClient":
                itemName = <Column
                    key={i}
                    header={'Реакція Клієнта'}
                    headerClassName='hidden'
                    className="justify-content-start"
                    body={(data) => data?.item?.reactionClient && data?.item?.reactionClient !== -1 ? convertSecondsToTime(data?.item?.reactionClient) : data?.item?.reactionClient === 0 ? '00:00:00' : '- - -'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '165px'}}
                />;
                break;
            case "reactionOperator":
                itemName = <Column
                    key={i}
                    header={'Реакція Оператора'}
                    className="justify-content-start"
                    headerClassName='hidden'
                    body={(data) => data?.item?.reactionOperator && data?.item?.reactionOperator !== -1 ? convertSecondsToTime(data?.item?.reactionOperator) : data?.item?.reactionOperator === 0 ? '00:00:00' : '- - -'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '165px'}}
                />;
                break;
            case "ownerType":
                let foundOwnerType = (ownerTypeId: any) => {
                    let ownerType = ownerTypeDictionary?.filter((status: any) => status?.dictionaryId === ownerTypeId);
                    return ownerType?.[0]?.description;
                }

                itemName = <Column
                    key={i}
                    body={(data) => foundOwnerType(data?.item?.ownerType) || ''}
                    header={'Завершення'}
                    headerClassName='hidden'
                    className="justify-content-start"
                    style={{cursor: 'pointer', width: `100%`, minWidth: '170px'}}
                />;
                break;
            case "end":
                itemName = <Column
                    key={i}
                    header={'Завершення'}
                    headerClassName='hidden'
                    className="justify-content-start"
                    body={(data) => data?.item?.end ? formatDateTime(data?.item?.end) : '- - -'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '170px'}}

                />;
                break;
            default:
                itemName = itemName = <Column
                    key={i}
                    header={'Завершення'}
                    className="justify-content-start"
                    headerClassName='hidden'
                    body={''}
                />;
        }

        return itemName;
    }

    const rowExpansionBSessionTemplate = (data: DataRow) => {
        return (
            <DataTable
                value={data?.children}
                className="p-datatable-customers monitoring-table monitoring-table-td monitoring-Expansion"
                selectionMode="single"
                rowClassName={dynamicBSessionRowClass}
                selection={selectedBSessionRowExpansion}
                onRowClick={(e) => {
                    setSelectedRowData(null);
                    handleResetPlayer();
                    dispatch(getEventMonitorToUserDetail(e.data.item.id, jwtToken?.jwtToken));
                    if (!isMobile) {
                        if (props.profileMenuPin === true) {
                            setSelectedRowExpansion(e.data);
                            setVisible(true);
                        } else {
                            setSelectedRowExpansion(e.data);
                        }
                    } else {
                        setSelectedRowExpansion(e.data);
                        setVisible(true);
                    }
                }}
                dataKey="item.bSessionId"
            >
                <Column headerClassName={'hidden'} body={BSessionIcon}
                        style={{minWidth: '6rem', display: 'flex', alignItems: 'center', justifyContent: 'end'}}/>
                {renderTableColumns(secondLevelTableCase)}
            </DataTable>
        );
    };

    const sessionBodyIcon = (rowData: any) => {
        if (rowData?.children?.length) {
            return <></>
        }
    }

    const rowExpansionTemplate = (data: DataRow) => {
        return (
            <DataTable
                value={data?.children}
                className="p-datatable-customers monitoring-table monitoring-table-td monitoring-Expansion"
                selectionMode="single"
                selection={selectedSessionRowExpansion}
                rowExpansionTemplate={rowExpansionBSessionTemplate}
                expandedRows={expandedSessionRows}
                onRowToggle={(e) => setExpandedSessionRows(e.data)}
                onRowClick={(e) => {
                    handleResetPlayer();
                    dispatch(getEventMonitorToUserDetail(e.data.item.id, jwtToken?.jwtToken));
                    setSelectedRowData(null);
                    if (!isMobile) {
                        if (props.profileMenuPin === true) {
                            setSelectedRowExpansion(e.data);
                            setVisible(true);
                        } else {
                            setSelectedRowExpansion(e.data);
                        }
                    } else {
                        setSelectedRowExpansion(e.data);
                        setVisible(true);
                    }
                }}
                dataKey="item.bSessionId"
            >
                <Column rowReorderIcon={'pi pi-close'} headerClassName={'hidden'} expander={allowExpansion}
                        style={{minWidth: '4rem', display: 'flex', alignItems: 'center', justifyContent: 'end'}}/>
                <Column headerClassName={'hidden'} body={sessionBodyIcon} expander={allowExpansion}
                        style={{minWidth: '2rem', display: 'flex', alignItems: 'center', justifyContent: 'center'}}/>
                {renderTableColumns(secondLevelTableCase)}
            </DataTable>
        );
    };

    const allowExpansion = (rowData: DataRow) => {
        return rowData.children?.length || false;
    };

    const collapseAll = () => {
        setExpandedRows(null);
    };

    const dynamicRowClass = (data: { item: any; }) => {
        if (data?.item?.bSessionId === selectedRowData?.item?.bSessionId) {
            return 'mainRowMonitoringTable p-highlight';
        }
        return 'mainRowMonitoringTable';
    };

    const dynamicBSessionRowClass = () => {
        return 'BSessionRow';
    };

    const copyDetailsLink = () => {
        let href = window.location.origin + '#/call_details/' + monitoringData?.id
        const copyToClipboard = (text: string) => {
            const tempElement = document.createElement('textarea');
            tempElement.value = text;
            document.body.appendChild(tempElement);
            tempElement.select();
            document.execCommand('copy');
            document.body.removeChild(tempElement);
        }
        copyToClipboard(href);
        dispatch({type: SET_USER_STATUS_SUCCESS, payload: {message: 'Посилання скопійована в буфер обміну'}});
    }

    const openDetailsLink = () => {
        console.log(window.location.origin);
        let href = window.location.origin + '#/call_details/' + monitoringData?.id + '?childWindow=1'
        window.open(href, '_blank')
    }

    const headerDialogBody = () => {
        return <div className="flex justify-content-start align-items-start" >
            <button className="close-button block cursor-pointer ml-0"
                    onClick={() => {
                        copyDetailsLink();
                    }
                    }><span className="pi pi-copy"></span>
            </button>
            {!props.isWindow && <button className="close-button block cursor-pointer ml-2"
                                        onClick={() => {
                                            openDetailsLink();
                                        }
                                        }><span className="pi pi-arrow-up-right-and-arrow-down-left-from-center"></span>
            </button>}
        </div>
    }
    const renderTable = () => {
        return (
            <div className="layout-dashboard">
                <div className="flex flex-wrap col-12 md:col-12">
                    <div
                        className={classNames('card widget-table mr-4 col-12 transition-duration-300 monitoring-table align-self-start monitoringLoader', {'': (selectedRowData || selectedRowExpansion) && !isMobile(), 'md:col-12': !(selectedRowData || selectedRowExpansion)})}>
                        <MonitoringListNav toggleButtonActivity={toggleButtonActivity} setToggleButtonActivity={setToggleButtonActivity} activityChangedManuallyRef={activityChangedManuallyRef} setActivity={setActivity} activity={activity} userSortFields={userSortFields?.fields} sortData={sortData}
                                           resetSorting={handleReset} toggleTab={toggleTab}
                                           activeTab={activeTab}/>
                        <DataTable
                            expandedRows={expandedRows}
                            onRowToggle={(e) => setExpandedRows(e.data)}
                            rowExpansionTemplate={rowExpansionTemplate}
                            scrollable
                            scrollHeight={(selectedRowData || selectedRowExpansion) && !isMobile() ? '40vh' : '70vh'}
                            ref={dataTableRef}
                            rows={10}
                            onSort={monitoringSort}
                            filters={clearFilters}
                            loading={loader}
                            rowsPerPageOptions={[5, 10, 25, 50]}
                            value={formattedData}
                            className="p-datatable-customers monitoring-table monitoring-table-rowGroup"
                            rowClassName={dynamicRowClass}
                            selectionMode="single"
                            emptyMessage="Нічого не знайдено"
                            rowHover={false}
                            onFilter={customFilter}
                            lazy
                            onRowClick={(e) => {
                                setSelectedRowExpansion(null);
                                handleResetPlayer();
                                dispatch(getEventMonitorToUserDetail(e.data.item.id, jwtToken?.jwtToken));
                                if (!isMobile) {
                                    if (props.profileMenuPin === true) {
                                        setSelectedRowData(e.data);
                                        setVisible(true);
                                    } else {
                                        setSelectedRowData(e.data);
                                    }
                                } else {
                                    setSelectedRowData(e.data);
                                    setVisible(true);
                                }
                            }} dataKey="item.bSessionId"
                        >
                            <Column rowReorderIcon={'pi pi-close'} expander={allowExpansion}
                                    style={{minWidth: '6rem'}}/>
                            {renderTableColumns(firstLevelTableCase)}
                        </DataTable>
                        <Paginator
                            first={first}
                            rows={paginationSize}
                            totalRecords={totalItems}
                            rowsPerPageOptions={[5, 10, 15, 25, 50]}
                            onPageChange={onPageChange}
                            className="border-top-1 border-bottom-1"
                            template="PrevPageLink PageLinks NextPageLink RowsPerPageDropdown"
                        />
                    </div>
                    {(selectedRowData || selectedRowExpansion) && monitoringData && (
                        <>
                            {windowWidth > 1248 && <div
                                className={classNames('card widget-table col-12 md:col-12 align-self-start sticky top-0')}>
                                <MonitoringListDetails setSelectedRowData={setSelectedRowData}
                                                       setSelectedRowExpansion={setSelectedRowExpansion}
                                                       handleResetPlayer={handleResetPlayer}/>
                            </div>}

                            {windowWidth <= 1248 && <div>
                                <Dialog visible={visible} header={headerDialogBody} className="monitoring-info" onHide={() => setVisible(false)}>
                                    <MonitoringListDetails setSelectedRowData={setSelectedRowData}
                                                           setSelectedRowExpansion={setSelectedRowExpansion}
                                                           handleResetPlayer={handleResetPlayer}/>
                                </Dialog>
                            </div>}
                        </>
                    )}
                </div>
            </div>
        );
    };

    return (
        <div>
            {renderTable()}
        </div>
    );
};

export default MonitoringBranches;
